<template>
    <div class="components-container">
        <div class="filter-container">
            <el-select v-model="queryForm.xnxqbm" filterable placeholder="学年学期" style="width:220px" clearable>
                <el-option v-for="item in xnxqInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-input v-model="queryForm.courseName" @keyup.enter.native="handleFilter" style="width: 180px" placeholder="课程名称" clearable>
            </el-input>
            <el-input v-model="queryForm.className" @keyup.enter.native="handleFilter" style="width: 180px" placeholder="班级名称" clearable>
            </el-input>
            <el-input v-model="queryForm.teacherName" @keyup.enter.native="handleFilter" style="width: 180px" placeholder="申请教师" clearable>
            </el-input>
            <el-select v-model="queryForm.applyType" filterable placeholder="申请类型" style="width:150px" clearable>
                <el-option v-for="item in applyInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-select v-model="queryForm.auditState" filterable placeholder="审核状态" style="width:150px" clearable>
                <el-option v-for="item in auditInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <!-- <el-date-picker type="date" placeholder="开始日期" v-model="queryForm.startTime" value-format="yyyy-MM-dd" style="width:200px;"></el-date-picker>
            <el-date-picker type="date" placeholder="结束日期" v-model="queryForm.endTime" value-format="yyyy-MM-dd" style="width:200px;"></el-date-picker> -->
            <el-button @click="handleFilter" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
            <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
            <el-button @click="addRec" type="success"><i class="el-icon-circle-plus-outline"></i>&nbsp;申请</el-button>
            <!-- <el-button @click="showExportDialog" type="primary"><i class="el-icon-download"></i>&nbsp;导出</el-button> -->
        </div>

        <el-table :data="tableData" @current-change="handleCurrentChange" v-loading.body="tableLoading" :cell-style="handleCellStyle"
            element-loading-text="信息加载中" highlight-current-row border style="width: 100%" :height="mainTableHeight" ref="mainTable">
            <el-table-column label="序号" width="50" align="center">
                <template slot-scope="scope">
                    <span>{{ (currentPage - 1) * limit + scope.$index + 1 }}</span>
                </template>
            </el-table-column>
            <el-table-column label="学年学期" prop="xnxqmc" align="center" min-width="15%"></el-table-column>
            <el-table-column label="申请教师" prop="creatorName" align="center" min-width="10%"></el-table-column>
            <el-table-column label="课程名称" prop="courseName" align="center" min-width="15%"></el-table-column>
            <el-table-column label="班级名称" prop="className" align="center" min-width="15%"></el-table-column>
            <el-table-column label="申请类型" prop="applyType" :formatter="applyTypeFormatter" align="center" min-width="10%"></el-table-column>
            <el-table-column label="变更理由" prop="changeReason" align="center" min-width="25%"></el-table-column>
            <el-table-column label="审核状态" prop="auditState" :formatter="auditStateFormatter" align="center" min-width="10%"></el-table-column>
            <el-table-column label="操作" align="center" min-width="15%">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.auditState == '-1' && scope.row.xnxqbm == curterm" size="small" @click="modRec(scope.row);" type="warning">
                        <i class="el-icon-edit"></i>&nbsp;编辑
                    </el-button>
                    <!-- <el-button v-if="scope.row.auditState == '-1'" size="small" @click="delRec(scope.row);" type="danger">
                        <i class="el-icon-delete"></i>&nbsp;删除
                    </el-button> -->
                    <el-button v-if="scope.row.auditState !='-1' && scope.row.auditAuth=='0' || scope.row.xnxqbm != curterm" size="small" @click="showDetailInfo(scope.row);" type="info">
                        <i class="el-icon-tickets"></i>&nbsp;详情
                    </el-button>
                    <el-button v-if="scope.row.auditAuth == '1' && scope.row.xnxqbm == curterm" size="small" @click="auditRec(scope.row);" type="primary">
                        <i class="el-icon-edit-outline"></i>&nbsp;审核
                    </el-button>
                    <el-button v-if="scope.row.auditState != '-1'" size="small" @click="showAuditList(scope.row);">
                        <i class="el-icon-document-copy"></i>&nbsp;审核信息
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange" :current-page.sync="currentPage"
                :page-sizes="[10, 20, 50]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>

        <el-dialog class="customElRow" :title="dialogTitle" :visible.sync="dialogVisible" @closed="closeDialog" width="1000px" top="80px" :close-on-click-modal="false">
            <div class="el-dialog-div">
                <el-form :model="curdForm" ref="curdForm" label-width="120px" label-position="left" width="100%" :rules="curdRules">
                    <!-- 新建，编辑 -->
                    <div v-if="editType=='new' || editType=='edit'">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="申请类型" prop="applyType">
                                    <el-select v-model="curdForm.applyType" filterable placeholder="请选择申请类型" style="width:100%;" @change="applyTypeChange">
                                        <el-option v-for="item in applyInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="申请教师" prop="applyTeacher">
                                    <span v-if="userAuth.indexOf('@1@')==-1 || (editType!='new' && editType!='edit') " style="line-height:40px;">{{ curdForm.applyTeacherName }}</span>
                                    <el-select v-if="userAuth.indexOf('@1@')>-1 && (editType=='new' || editType=='edit')" v-model="curdForm.applyTeacher" filterable placeholder="请选择申请教师" style="width:100%;" @change="applyTeacherChange">
                                        <el-option v-for="item in teacherInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="专业名称" prop="majorCode">
                                    <el-select v-model="curdForm.majorCode" filterable :placeholder="majorholder" style="width:100%;" @change="applyMajorChange" :disabled="disabled_major">
                                        <el-option v-for="item in majorInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="班级名称" prop="classCode">
                                    <el-select v-model="curdForm.classCode" filterable :placeholder="classholder" style="width:100%;" @change="applyClassChange" :disabled="disabled_class">
                                        <el-option v-for="item in classInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="课程名称" prop="courseCode">
                                    <el-select v-model="curdForm.courseCode" filterable :placeholder="courseholder" style="width:100%;" @change="applyCourseChange" :disabled="disabled_course">
                                        <el-option v-for="item in courseInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="调课原因" prop="adjustReason">
                                    <el-select v-model="curdForm.adjustReason" filterable placeholder="请选择调课原因" style="width:60%;" @change="adjustReasonChange">
                                        <el-option v-for="item in adjustReasonInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                        </el-option>
                                    </el-select>
                                    <el-button v-show="uploadButton" size="medium" style="margin-left:10px;" @click="showUpload" type="success"><i class="el-icon-upload2"></i>&nbsp;附件上传</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-form-item label="变更理由" prop="changeReason">
                            <el-input v-model="curdForm.changeReason" placeholder="请填写变更理由" autoComplete="on" type="textarea"
                                :rows="3" show-word-limit maxlength="500"></el-input>
                        </el-form-item>

                        <!-- 调课 -->
                        <div v-if="adjustFlag=='1'">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="原计划授课时间" >
                                        <div>
                                            <span>周数</span>
                                            <el-select v-model="curdForm.yjhskzc" filterable placeholder="请选择周数" style="width:80%;margin-left:10%;" @change="yjhskzcChange" multiple>
                                                <el-option v-for="item in yjhskzcInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div style="margin-top:10px;">
                                            <span>星期</span>
                                            <el-select v-model="curdForm.yjhxq" filterable placeholder="请选择星期" style="width:80%;margin-left:10%;" @change="yjhxqChange">
                                                <el-option v-for="item in yjhxqInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div style="margin-top:10px;">
                                            <span>节数</span>
                                            <el-select v-model="curdForm.yjhsjxl" filterable placeholder="请选择节数" style="width:80%;margin-left:10%;" @change="yjhsjxlChange" multiple>
                                                <el-option v-for="item in yjhsjxlInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="申请调整的授课时间">
                                        <div>
                                            <span>周数</span>
                                            <el-select v-model="curdForm.tzhskzc" filterable placeholder="请选择周数" style="width:80%;margin-left:10%;" @change="tzhskzcChange" multiple>
                                                <el-option v-for="item in tzhskzcInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div style="margin-top:10px;">
                                            <span>星期</span>
                                            <el-select v-model="curdForm.tzhxq" filterable placeholder="请选择星期" style="width:80%;margin-left:10%;" @change="tzhxqChange">
                                                <el-option v-for="item in tzhxqInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div style="margin-top:10px;">
                                            <span>节数</span>
                                            <el-select v-model="curdForm.tzhsjxl" filterable placeholder="请选择节数" style="width:80%;margin-left:10%;" @change="tzhsjxlChange" multiple>
                                                <el-option v-for="item in tzhsjxlInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="授课教师" >
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="授课地点">
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="12">
                                        <span style="margin-left:40px;line-height:40px;">{{ curdForm.yjhskjsxm }}</span>
                                        <!-- <span style="margin-left:40px;line-height:40px;">教师姓名  ===》</span> -->

                                        <!-- <el-select v-model="curdForm.tzhskjsbh" filterable placeholder="请选择授课教师" style="width:96%;">
                                            <el-option v-for="item in teacherInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                            </el-option>
                                        </el-select> -->
                                </el-col>
                                <el-col :span="12">
                                        <span v-if="sameFlag!='true'" style="margin-left:40px;line-height:40px;">{{ curdForm.yjhcdmc }}</span>

                                        <div v-for="(site,i) in yjhsiteList" style="margin-top:5px;">
                                            <span v-if="sameFlag=='true'" style="margin-left:40px;line-height:40px;">{{ yjhsiteList[i].name }}  ===》</span>
                                            <el-select v-if="sameFlag=='true'" v-model="tzhsiteList[i].value" filterable placeholder="请选择授课地点" style="width:50%;" @change="siteChange(tzhsiteList[i].value,i)">
                                                <el-option v-for="item in tzhsiteInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                                </el-option>
                                            </el-select>
                                        </div>
                                </el-col>
                            </el-row>

                            <!-- <el-form-item label="其它说明" prop="otherExplain">
                                <el-input v-model="curdForm.otherExplain" placeholder="请填写其它说明" autoComplete="on" type="textarea"
                                    :rows="3" show-word-limit maxlength="500"></el-input>
                            </el-form-item> -->
                        </div>

                        <!-- 代课 -->
                        <div v-if="adjustFlag=='4'">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="代课时间" >
                                        <div>
                                            <span>周数</span>
                                            <el-select v-model="curdForm.yjhskzc" filterable placeholder="请选择周数" style="width:80%;margin-left:10%;" @change="yjhskzcChange" multiple>
                                                <el-option v-for="item in yjhskzcInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div style="margin-top:10px;">
                                            <span>星期</span>
                                            <el-select v-model="curdForm.yjhxq" filterable placeholder="请选择星期" style="width:80%;margin-left:10%;" @change="yjhxqChange">
                                                <el-option v-for="item in yjhxqInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div style="margin-top:10px;">
                                            <span>节数</span>
                                            <el-select v-model="curdForm.yjhsjxl" filterable placeholder="请选择节数" style="width:80%;margin-left:10%;" @change="yjhsjxlChange" multiple>
                                                <el-option v-for="item in yjhsjxlInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="授课教师" >
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="授课地点">
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="12">
                                        <span v-if="sameFlag!='true'" style="margin-left:40px;line-height:40px;">{{ curdForm.yjhskjsbh }}</span>

                                        <div v-for="(tea,i) in yjhteaList" style="margin-top:10px;">
                                            <span v-if="sameFlag=='true'" style="margin-left:40px;line-height:40px;">{{ yjhteaList[i].name }}  ===》</span>
                                            <el-select v-if="sameFlag=='true'" v-model="tzhteaList[i].value" filterable placeholder="请选择授课地点" style="width:50%;" @change="teaChange(tzhteaList[i].value,i)">
                                                <el-option v-for="item in tzhteacherInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                                </el-option>
                                            </el-select>
                                        </div>
                                </el-col>
                                <el-col :span="12">
                                        <span v-if="sameFlag!='true'" style="margin-left:40px;line-height:40px;">{{ curdForm.yjhcdmc }}</span>

                                        <div v-for="(site,i) in yjhsiteList" style="margin-top:10px;">
                                            <span v-if="sameFlag=='true'" style="margin-left:40px;line-height:40px;">{{ yjhsiteList[i].name }}  ===》</span>
                                            <el-select v-if="sameFlag=='true'" v-model="tzhsiteList[i].value" filterable placeholder="请选择授课地点" style="width:50%;" @change="siteChange(tzhsiteList[i].value,i)">
                                                <el-option v-for="item in tzhsiteInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                                </el-option>
                                            </el-select>
                                        </div>
                                </el-col>
                            </el-row>

                            <!-- <el-form-item label="其它说明" prop="otherExplain">
                                <el-input v-model="curdForm.otherExplain" placeholder="请填写其它说明" autoComplete="on" type="textarea"
                                    :rows="3" show-word-limit maxlength="500"></el-input>
                            </el-form-item> -->
                        </div>

                        <!-- 补课 -->
                        <div v-if="adjustFlag=='3'">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="补课时间" >
                                        <div>
                                            <span>周数</span>
                                            <el-select v-model="curdForm.tzhskzc" filterable placeholder="请选择周数" style="width:80%;margin-left:10%;" @change="tzhskzcChange" multiple>
                                                <el-option v-for="item in tzhskzcInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div style="margin-top:10px;">
                                            <span>星期</span>
                                            <el-select v-model="curdForm.tzhxq" filterable placeholder="请选择星期" style="width:80%;margin-left:10%;" @change="tzhxqChange">
                                                <el-option v-for="item in tzhxqInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div style="margin-top:10px;">
                                            <span>节数</span>
                                            <el-select v-model="curdForm.tzhsjxl" filterable placeholder="请选择节数" style="width:80%;margin-left:10%;" @change="tzhsjxlChange" multiple>
                                                <el-option v-for="item in tzhsjxlInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="授课教师" >
                                        <el-select v-model="curdForm.tzhskjsbh" filterable placeholder="请选择授课教师" style="width:90%;" multiple>
                                            <el-option v-for="item in tzhteacherInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="授课地点">
                                        <el-select v-model="curdForm.tzhcdbh" filterable placeholder="请选择授课地点" style="width:90%;" multiple>
                                            <el-option v-for="item in tzhsiteInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <!-- <el-form-item label="其它说明" prop="otherExplain">
                                <el-input v-model="curdForm.otherExplain" placeholder="请填写其它说明" autoComplete="on" type="textarea"
                                    :rows="3" show-word-limit maxlength="500"></el-input>
                            </el-form-item> -->
                        </div>

                        <!-- 停课 -->
                        <div v-if="adjustFlag=='2'">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="停课时间" >
                                        <div>
                                            <span>周数</span>
                                            <el-select v-model="curdForm.yjhskzc" filterable placeholder="请选择周数" style="width:80%;margin-left:10%;" @change="yjhskzcChange" multiple>
                                                <el-option v-for="item in yjhskzcInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div style="margin-top:10px;">
                                            <span>星期</span>
                                            <el-select v-model="curdForm.yjhxq" filterable placeholder="请选择星期" style="width:80%;margin-left:10%;" @change="yjhxqChange">
                                                <el-option v-for="item in yjhxqInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <div style="margin-top:10px;">
                                            <span>节数</span>
                                            <el-select v-model="curdForm.yjhsjxl" filterable placeholder="请选择节数" style="width:80%;margin-left:10%;" @change="yjhsjxlChange" multiple>
                                                <el-option v-for="item in yjhsjxlInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="授课教师">
                                        <span style="margin-left:40px;line-height:40px;">{{ curdForm.yjhskjsxm }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="授课地点">
                                        <span style="margin-left:40px;line-height:40px;">{{ curdForm.yjhcdmc }}</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <!-- <el-form-item label="其它说明" prop="otherExplain">
                                <el-input v-model="curdForm.otherExplain" placeholder="请填写其它说明" autoComplete="on" type="textarea"
                                    :rows="3" show-word-limit maxlength="500"></el-input>
                            </el-form-item> -->
                        </div>
                    </div>

                    <!-- 审核，详情 -->
                    <div v-if="editType=='audit' || editType=='show'">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="申请类型" prop="applyType">
                                    {{ curdForm.applyTypeName }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="申请教师" prop="applyTeacher">
                                    {{ curdForm.applyTeacherName }}
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="专业名称" prop="majorCode">
                                    {{ curdForm.majorName }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="班级名称" prop="classCode">
                                    {{ curdForm.className }}
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="课程名称" prop="courseCode">
                                    {{ curdForm.courseName }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="调课原因" prop="adjustReason">
                                    {{ curdForm.adjustReasonName }}
                                    <el-button v-show="uploadButton" size="medium" style="margin-left:100px;" @click="showUpload" type="success"><i class="el-icon-upload2"></i>&nbsp;附件上传</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-form-item label="变更理由" prop="changeReason">
                            <div style="height:50px;">
                                {{ curdForm.changeReason }}
                            </div>
                        </el-form-item>

                        <!-- 调课 -->
                        <div v-if="adjustFlag=='1'">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="原计划授课时间" >
                                        <div>
                                            <span>周数</span>
                                            <span style="margin-left:40px;">{{ curdForm.yjhskzc+'' }}</span>
                                        </div>
                                        <div style="margin-top:10px;">
                                            <span>星期</span>
                                            <span style="margin-left:40px;">{{ parseInt(curdForm.yjhxq,10) }}</span>
                                        </div>
                                        <div style="margin-top:10px;">
                                            <span>节数</span>
                                            <span style="margin-left:40px;">{{ formatJS(curdForm.yjhsjxl+'') }}</span>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="申请调整的授课时间">
                                        <div>
                                            <span>周数</span>
                                            <span style="margin-left:40px;">{{ curdForm.tzhskzc+'' }}</span>
                                        </div>
                                        <div style="margin-top:5px;">
                                            <span>星期</span>
                                            <span style="margin-left:40px;">{{ parseInt(curdForm.tzhxq,10) }}</span>
                                        </div>
                                        <div style="margin-top:5px;">
                                            <span>节数</span>
                                            <span style="margin-left:40px;">{{ formatJS(curdForm.tzhsjxl+'') }}</span>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="授课教师" >
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="授课地点">
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="12">
                                    <span style="margin-left:40px;">{{ curdForm.yjhskjsxm+'' }}</span>
                                </el-col>
                                <el-col :span="12">
                                    <div v-for="(site,i) in yjhsiteList" style="margin-top:10px;">
                                        <span style="margin-left:40px;">{{ yjhsiteList[i].name+'' }} ===》 {{ tzhsiteList[i].name+'' }}</span>
                                    </div>
                                </el-col>
                            </el-row>

                            <!-- <el-form-item label="其它说明" prop="otherExplain">
                                <div style="height:50px;">
                                    {{ curdForm.otherExplain }}
                                </div>
                            </el-form-item> -->
                        </div>

                        <!-- 代课 -->
                        <div v-if="adjustFlag=='4'">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="代课时间" >
                                        <div>
                                            <span>周数</span>
                                            <span style="margin-left:40px;">{{ curdForm.yjhskzc+'' }}</span>
                                        </div>
                                        <div style="margin-top:5px;">
                                            <span>星期</span>
                                            <span style="margin-left:40px;">{{ parseInt(curdForm.yjhxq,10) }}</span>
                                        </div>
                                        <div style="margin-top:5px;">
                                            <span>节数</span>
                                            <span style="margin-left:40px;">{{ formatJS(curdForm.yjhsjxl+'') }}</span>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="授课教师" >
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="授课地点">
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="12">
                                    <div v-for="(tea,i) in yjhteaList" style="margin-top:10px;">
                                        <span style="margin-left:40px;">{{ yjhteaList[i].name+'' }} ===》 {{ tzhteaList[i].name+'' }}</span>
                                    </div>
                                </el-col>
                                <el-col :span="12">
                                    <div v-for="(site,i) in yjhsiteList" style="margin-top:10px;">
                                        <span style="margin-left:40px;">{{ yjhsiteList[i].name+'' }} ===》 {{ tzhsiteList[i].name+'' }}</span>
                                    </div>
                                </el-col>
                            </el-row>

                            <!-- <el-form-item label="其它说明" prop="otherExplain">
                                <div style="height:50px;">
                                    {{ curdForm.otherExplain }}
                                </div>
                            </el-form-item> -->
                        </div>

                        <!-- 补课 -->
                        <div v-if="adjustFlag=='3'">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="补课时间" >
                                        <div>
                                            <span>周数</span>
                                            <span style="margin-left:40px;">{{ curdForm.tzhskzc+'' }}</span>
                                        </div>
                                        <div style="margin-top:5px;">
                                            <span>星期</span>
                                            <span style="margin-left:40px;">{{ parseInt(curdForm.tzhxq,10) }}</span>
                                        </div>
                                        <div style="margin-top:5px;">
                                            <span>节数</span>
                                            <span style="margin-left:40px;">{{ formatJS(curdForm.tzhsjxl+'') }}</span>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="授课教师" >
                                        <span style="margin-left:40px;">{{ curdForm.tzhskjsxm+'' }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="授课地点">
                                        <span style="margin-left:40px;">{{ curdForm.tzhcdmc+'' }}</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <!-- <el-form-item label="其它说明" prop="otherExplain">
                                <div style="height:50px;">
                                    {{ curdForm.otherExplain }}
                                </div>
                            </el-form-item> -->
                        </div>

                        <!-- 停课 -->
                        <div v-if="adjustFlag=='2'">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="停课时间" >
                                        <div>
                                            <span>周数</span>
                                            <span style="margin-left:40px;">{{ curdForm.yjhskzc+'' }}</span>
                                        </div>
                                        <div style="margin-top:5px;">
                                            <span>星期</span>
                                            <span style="margin-left:40px;">{{ parseInt(curdForm.yjhxq,10) }}</span>
                                        </div>
                                        <div style="margin-top:5px;">
                                            <span>节数</span>
                                            <span style="margin-left:40px;">{{ formatJS(curdForm.yjhsjxl+'') }}</span>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="授课教师">
                                        <span style="margin-left:40px;">{{ curdForm.yjhskjsxm+'' }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="授课地点">
                                        <span style="margin-left:40px;">{{ curdForm.yjhcdmc+'' }}</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <!-- <el-form-item label="其它说明" prop="otherExplain">
                                <div style="height:50px;">
                                    {{ curdForm.otherExplain }}
                                </div>
                            </el-form-item> -->
                        </div>
                    </div>
                </el-form>
            </div>

            <div slot="footer" class="dialog-footer" style="margin-top: 10px">
                <el-button v-if="curdForm.applyType == '1'" type="success" :loading="formSubmiting" @click="singleTimeTable()">课程课表</el-button>
                <el-button v-if="auditDisabled == false && editType!='show'" type="primary" :loading="formSubmiting" @click="saveInfo()">保 存</el-button>
                <el-button v-if="auditDisabled == false && editType!='show'" type="warning" :loading="formSubmiting" @click="submitRec()">提 交</el-button>
                <el-button v-if="auditDisabled == true && editType!='show' && applyused==false" :disabled="applyused" type="warning" :loading="formSubmiting" @click="auditOption();">审核意见</el-button>
                <el-button v-if="editType!='show'" @click="dialogVisible = false">取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog title="附件上传" :visible.sync="attachmentVisible" width="800px" style="top:50px;" @close="closeAttachDialog" append-to-body>
            <div style="height:420px;">
                <el-table :data="fileTableData" v-loading.body="fileTableLoading" element-loading-text="数据加载中"
                    style="width: 100%;margin-top:15px;" :height="fileTableHeight" ref="multipleTable" stripe border fit>
                    <el-table-column v-if="operateAreaVisible" type="selection" width="55"></el-table-column>
                    <el-table-column label="文件名" prop="fileName" align="center" min-width="40%"></el-table-column>
                    <el-table-column label="文件类型" prop="fileType" align="center" width="150px"></el-table-column>
                    <el-table-column align="center" width="200">
                        <template slot="header" slot-scope="scope">
                            <div v-show="operateAreaVisible">
                                <el-button size="small" @click="clickUpload" type="success"><i class="el-icon-upload2"></i>&nbsp;上传</el-button>
                                <el-button size="small" @click="confirmDelFile" type="danger"><i class="el-icon-delete"></i>&nbsp;删除</el-button>
                            </div>
                            <div v-if="viewAreaVisible">操作</div>
                        </template>
                        <template slot-scope="scope">
                            <el-button size="small" @click="showAttachment(scope.row);" type="primary">
                                <i class="el-icon-view"></i>&nbsp;预览
                            </el-button>
                            <el-button size="small" @click="downloadAttachment(scope.row);" type="primary">
                                <i class="el-icon-download"></i>&nbsp;下载
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>

        <el-dialog title="附件上传" :visible.sync="uploadDialogVisible" width="520px" style="top:50px;" @close="closeUploadDialog" append-to-body>
            <div class="attachmentUpload" style="width: 100%;">
                <el-upload class="upload-demo" ref="uploadFile" drag action="#" :file-list="fileList" :http-request="getFile"
                    :multiple="multipleType" :auto-upload="false" :limit="10" :on-change="onChangeFile" :on-success="handleFilUploadSuccess"
                    :on-remove="handleRemove" :on-exceed="handleExceed">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                        <div style="font-size:16px; font-weight:bold;">将文件拖到此处，或<em>点击上传</em></div>
                        <div style="margin-top:30px; font-size:16px; font-weight:bold;">
                            <el-tooltip placement="top">
                                <div slot="content">
                                    允许上传的文件类型如下（单个文件大小{{ fileSizeLimit }}MB以内）<br/>
                                    文本文件：txt、doc、docx、xls、xlsx、pdf、ppt、pptx<br/>
                                    图片文件：jpg、jpeg、png、gif<br/>
                                    音/视频文件：mp3、mp4
                                </div>
                                <el-button plain>查看上传文件限制</el-button>
                            </el-tooltip>
                        </div>
                    </div>
                </el-upload>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleUpload">确 定</el-button>
                <el-button @click="closeUploadDialog">取 消</el-button>
            </span>
        </el-dialog>

        <el-dialog title="课程课表" :visible.sync="singleTimeTableVisible" width="1300px" top="50px" @close="closeTimeTableDialog" append-to-body>
            <div id="loadingMask_kb" class="maskStyle">
                <div class="maskFont">验证上课时间中，请稍候...</div>
            </div>
            <div class="el-dialog-timetable">
                <el-row>
                    <el-col :span="24" class="row-label">
                        <span>原课程上课时间</span>
                        <el-select v-model="tkjc" filterable placeholder="请选择" style="width:300px;margin-left:10px;" @change="tkjcChange">
                            <el-option v-for="item in tkjcInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" class="row-label">
                        <table class="timetable" v-loading="timetableLoading" element-loading-text="课表加载中"
                            element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
                            <tr>
                                <td class="timetableTitle separetor" colspan="3"></td>
                                <td class="timetableTitle separetor" v-for="(item, index) in weekDayName">{{ item }}</td>
                            </tr>
                            <tr v-if="forenoonNum > 0">
                                <td class="timetableTitle separetor" :rowspan="forenoonNum" style="width:3%;">上<br /><br />午
                                </td>
                                <td class="timetableTitle" style="width:2%;">1</td>
                                <td class="timetableTitle" style="width:7%">{{ timeQuantum[0] }}</td>
                                <td v-for="m in weekDayNum" :id="'cell_' + (m-1)" :style="{width: 88/weekDayNum + '%'}">
                                </td>
                            </tr>
                            <template v-if="forenoonNum > 1">
                                <tr v-for="n in forenoonNum-1">
                                    <td :class="n < forenoonNum-1 ? 'timetableTitle' : 'timetableTitle separetor'">{{ n+1 }}
                                    </td>
                                    <td :class="n < forenoonNum-1 ? 'timetableTitle' : 'timetableTitle separetor'">
                                        {{ timeQuantum[n] }}
                                    </td>
                                    <td :class="n < forenoonNum-1 ? '' : 'separetor'" v-for="m in weekDayNum"
                                        :id="'cell_' + (n*weekDayNum + m-1)"></td>
                                </tr>
                            </template>
                            <tr v-if="noonNum > 0">
                                <td class="timetableTitle separetor" :rowspan="noonNum">中<br /><br />午</td>
                                <td class="timetableTitle">1</td>
                                <td class="timetableTitle">{{ timeQuantum[forenoonNum] }}</td>
                                <td v-for="m in weekDayNum" :id="'cell_' + (forenoonNum*weekDayNum + m-1)"></td>
                            </tr>
                            <template v-if="noonNum > 1">
                                <tr v-for="n in noonNum-1">
                                    <td :class="n < noonNum-1 ? 'timetableTitle' : 'timetableTitle separetor'">{{ n+1 }}
                                    </td>
                                    <td :class="n < noonNum-1 ? 'timetableTitle' : 'timetableTitle separetor'">
                                        {{ timeQuantum[forenoonNum+n] }}
                                    </td>
                                    <td :class="n < noonNum-1 ? '' : 'separetor'" v-for="m in weekDayNum"
                                        :id="'cell_' + (forenoonNum*weekDayNum + n*weekDayNum + m-1)"></td>
                                </tr>
                            </template>
                            <tr v-if="afternoonNum > 0">
                                <td class="timetableTitle separetor" :rowspan="afternoonNum">下<br /><br />午</td>
                                <td class="timetableTitle">1</td>
                                <td class="timetableTitle">{{ timeQuantum[forenoonNum+noonNum] }}</td>
                                <td v-for="m in weekDayNum"
                                    :id="'cell_' + (forenoonNum*weekDayNum + noonNum*weekDayNum + m-1)">
                                </td>
                            </tr>
                            <template v-if="afternoonNum > 1">
                                <tr v-for="n in afternoonNum-1">
                                    <td :class="n < afternoonNum-1 ? 'timetableTitle' : 'timetableTitle separetor'">
                                        {{ n+1 }}
                                    </td>
                                    <td :class="n < afternoonNum-1 ? 'timetableTitle' : 'timetableTitle separetor'">
                                        {{ timeQuantum[forenoonNum+noonNum+n] }}
                                    </td>
                                    <td :class="n < afternoonNum-1 ? '' : 'separetor'" v-for="m in weekDayNum"
                                        :id="'cell_' + (forenoonNum*weekDayNum + noonNum*weekDayNum + n*weekDayNum + m-1)">
                                    </td>
                                </tr>
                            </template>
                            <tr v-if="eveningNum > 0">
                                <td class="timetableTitle" :rowspan="eveningNum">晚<br /><br />上</td>
                                <td class="timetableTitle">1</td>
                                <td class="timetableTitle">{{ timeQuantum[forenoonNum+noonNum+afternoonNum] }}</td>
                                <td v-for="m in weekDayNum"
                                    :id="'cell_' + (forenoonNum*weekDayNum + noonNum*weekDayNum + afternoonNum*weekDayNum + m-1)">
                                </td>
                            </tr>
                            <template v-if="eveningNum > 1">
                                <tr v-for="n in eveningNum-1">
                                    <td class="timetableTitle">{{ n+1 }}</td>
                                    <td class="timetableTitle">{{ timeQuantum[forenoonNum+noonNum+afternoonNum+n] }}</td>
                                    <td v-for="m in weekDayNum"
                                        :id="'cell_' + (forenoonNum*weekDayNum + noonNum*weekDayNum + afternoonNum*weekDayNum + n*weekDayNum + m-1)">
                                    </td>
                                </tr>
                            </template>
                        </table>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>

        <!-- 审核dialog -->
        <el-dialog :title="detailDialogTitle" :visible.sync="detailDialogVisible" v-if="detailDialogVisible" width="600px" top="300px">
            <div style="height:170px;">
                <audit ref="audit" :key="timer" :itemCode="queryForm.itemCode" :relatedCode="selectRowData.id" :auditLevel="curdForm.auditLevel"
                    @auditCallback="auditCallback"></audit>
            </div>
        </el-dialog>

        <el-dialog title="审核信息" :visible.sync="auditListDialogVisible" v-if="auditListDialogVisible" width="900px" top="150px">
            <div style="height:550px;">
                <auditList ref="auditList" :relatedCode="selectRowData.id" :listHeight="450" :auditFlowInfo="auditFlowInfo"></auditList>
            </div>
        </el-dialog>

		<!-- 文件预览 -->
		<previewer v-if="previewerVisible" ref="previewer" :fileInfo="fileInfo"
		    :widthPercent="60" :heightNum="650" :topNum="60"
		    @closePreviewer="previewerVisible = false;">
		</previewer>

        <el-dialog title="批量导出" :visible.sync="exportDialogVisible" @closed="closeExportDialog" width="540px" top="20vh">
            <el-form :model="exportForm" ref="exportForm" label-width="130px" label-position="left" width="100%">
                <el-row>
                    <el-form-item label="学年学期" prop="xnxqbm">
                        <el-select v-model="exportForm.xnxqbm" placeholder="学年学期" style="width: 100%;">
                            <el-option v-for="(item, index) in xnxqInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>

                <el-row>
                    <el-form-item label="原计划教师" prop="teacherCode">
                        <el-select v-model="exportForm.teacherCode" placeholder="原计划教师" style="width:100%;" clearable filterable>
                            <el-option v-for="(item, index) in teacherInfo" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="班级名称" prop="classCode">
                        <el-select v-model="exportForm.classCode" placeholder="班级名称" style="width:100%;" clearable filterable>
                            <el-option v-for="(item, index) in exportClassInfo" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <!-- <el-row>
                    <el-form-item label="课程名称" prop="courseCode">
                        <el-select v-model="exportForm.courseCode" placeholder="课程名称" style="width:100%;" clearable filterable>
                            <el-option v-for="(item, index) in exportCourseInfo" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row> -->
                <el-row>
                    <el-form-item label="周次范围" prop="skzc">
                        <el-select v-model="exportForm.kszc" placeholder="起始周次" style="width:160px;" clearable>
                            <el-option v-for="(item, index) in skzcInfo" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                            </el-option>
                        </el-select>
                        &nbsp;至&nbsp;
                        <el-select v-model="exportForm.jszc" placeholder="结束周次" style="width:160px;" clearable>
                            <el-option v-for="(item, index) in skzcInfo" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="exportAdjustInfo" type="primary" style="margin-left: 10px;"><i class="el-icon-document">&nbsp;导出</i></el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { globalConfig } from 'static/config'
    import { confirmMsg, showNotify } from 'utils/message';
    import audit from 'views/audit/audit.vue';
    import auditList from 'views/audit/auditList.vue';
    import previewer from 'views/file/previewer.vue';

    export default {
        components: {
            audit,
            auditList,
            previewer,
        },
        data() {
            return {
                comboData: {
                    changeCode: null,
                    major: null,
                    class: null,
                },
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    xnxqbm: null,
                    courseName: null,
                    className: null,
                    teacherName: null,
                    applyType: null,
                    auditState: '',
                },
                timer: '', //时间戳,点击重新加载子页面
                tableData: [],
                currentPage: 1,
                limit: 10,
                total: null,
                tableLoading: false,
                selectRowData: null,
                selectRowDateTime: null,
                mainTableHeight: 500,
                fileTableHeight: 400,
                dialogTitle: "",
                dialogVisible: false,
                fieldVisible: false,
                schoolVisible: false,
                majorVisible: false,
                classVisible: false,
                attachmentVisible: false,
                operateAreaVisible: true,
                viewAreaVisible: false,

                uploadButton: false,
                fileTableLoading: false,
                fileTableData: [],
                uploadDialogVisible: false,
                multipleType: true, //上传 单个/多个文件//file: null, //上传选中的文件
                fileList: [], //上传选中的多个文件
                fileInfo: {
                    name: null,
                    type: null,
                    url: null,
                },
                previewerVisible: false,
                singleTimeTableVisible: false,
                fileName: null,
                fileSizeLimit: 100,
                students: [],
                stuInfo: null,
                curdForm: {
                    id: '',
                    xnxqbm: '',
                    xnxqmc: '',
                    applyType: '',
                    applyTypeName: '',
                    applyTeacher: '',
                    applyTeacherName: '',
                    majorCode: '',
                    majorName: '',
                    classCode: '',
                    className: '',
                    courseCode: '',
                    courseName: '',
                    adjustReason: '',
                    adjustReasonName: '',
                    changeReason: '',
                    yjhskzc: '',
                    yjhxq: '',
                    yjhsjxl: '',
                    yjhskjsbh: '',
                    yjhskjsxm: '',
                    yjhcdbh: '',
                    yjhcdmc: '',
                    tzhskzc: '',
                    tzhxq: '',
                    tzhsjxl: '',
                    tzhskjsbh: '',
                    tzhskjsxm: '',
                    tzhcdbh: '',
                    tzhcdmc: '',
                    otherExplain: '',
                    submitState: '',
                    auditState: '',
                    auditLevel: '',
                    auditAuth: '',
                    totalAuditLevel: '',
                    stuConfirmState: '',
                    stuSuggestion: '',
                },
                curdRules: {
                    xnxqbm: [{required: true, message: "请选择学年学期", trigger: ["blur", "change"],}],
                    siteCode: [{required: true, message: "请选择申请场地", trigger: ["blur", "change"],}],
                    useDescription: [{required: true, message: "请填写使用说明", trigger: ["blur"],}],
                },
                formSubmiting: false,
                detailDialogTitle: '',
                detailDialogTop: '150px',
                detailDialogVisible: false,
                auditAreaVisible: false,
                auditListDialogVisible: false,
                auditParam: null,
                userCode: null,
                userName: null,
                userAuth: null,
                maskHeight: null,
                auditFlowInfo: null,

                xnxqInfo: [],//学年学期
                applyInfo: [], //场地信息
                auditInfo: [], //审核状态
                teacherInfo:[], //教师列表
                majorInfo: [], //专业
                classInfo: [], //班级
                courseInfo: [], //课程
                yjhskzcInfo: [],//授课周次
                yjhxqInfo: [],//星期
                yjhsjxlInfo: [],//节次
                tzhskzcInfo: [],//授课周次
                tzhxqInfo: [],//星期
                tzhsjxlInfo: [],//节次
                adjustFlag: null,
                adjustReasonInfo: [], //调课原因
                tzhteacherInfo:[],
                tzhsiteInfo:[],
                changeFlag: null,
                saveing: false,//保存时禁用
                applyused: false,//课表信息有变更时禁用

                yjhteaList: [],
                yjhsiteList: [],
                tzhteaList: [],
                tzhsiteList: [],
                curterm: '',//当前学期
                disabled_major: true,
                disabled_class: true,
                disabled_course: true,
                majorholder: '',
                classholder: '',
                courseholder: '',
                sameFlag: 'true',
                errorFlag: '',

                auditDisabled: false,
                editType: null,
                editTimeType: null,
                editapplyDate: null,
                edituseTime: null,
                auditLevel: '',
                xgbh: null,
                numarray: [],
                weekarray: [],
                totalAuditLevel: null,

                //课表基本参数
                weekDayNum: null,
                weekDayName: null,
                forenoonNum: null,
                noonNum: null,
                afternoonNum: null,
                eveningNum: null,
                timeQuantum: [],
                //课表内容
                timetableInfo: null,
                cellContent: [],
                timetableLoading: false,
                tkjc: null,
                tkjcInfo: [],

                exportForm: {
                    xnxqbm: '',
                    xnxqmc: '',
                    teacherCode: '',
                    classCode: '',
                    courseCode: '',
                    kszc: '',
                    jszc: '',
                    tkType: '',
                    source: '',
                },
                exportDialogVisible: false,
                exportClassInfo: [],
                exportCourseInfo: [],
                skzcInfo: [],//授课周次
                btkxxDialogVisible: false,
                btkxxData: [],
                btkxxTableHeight: 400,
            };
        },
        mounted() {
            this.applyInfo = [{"comboValue":"1","comboName":"调课"},{"comboValue":"2","comboName":"停课"},{"comboValue":"3","comboName":"补课"},{"comboValue":"4","comboName":"代课"}];
            this.numarray = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
            this.weekarray = ["一", "二", "三", "四", "五", "六", "日"];
            this.curdForm.applyType = "1";

            this.initOption();

            this.$nextTick().then(() => {
                //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
                //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
                this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;
                // 监听窗口大小变化
                let self = this;
                window.onresize = function() {
                    self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145;
                };
            });
        },
        methods: {
            applyTypeFormatter(row){
                let str = '';
                if(row.applyType === '1'){
                    str = '调课';
                }else if(row.applyType === '2'){
                    str = '停课';
                }else if(row.applyType === '3'){
                    str = '补课';
                }else if(row.applyType === '4'){
                    str = '代课';
                }
                return str;
            },
            auditStateFormatter(row){
                let str = '';
                if(row.auditState === '-1'){
                    str = '未提交';
                }else if(row.auditState === '4'){
                    str = '待学生确认';
                }else if(row.auditState === '0'){
                    str = '待审核';
                }else if(row.auditState === '3'){
                    str = '审核中';
                }else if(row.auditState === '1'){
                    str = '审核通过';
                }else if(row.auditState === '2'){
                    str = '审核驳回';
                }else if(row.auditState === '5'){
                    str = '学生不同意';
                }
                return str;
            },
            //审状态列样式处理
            handleCellStyle({row, column, rowIndex, columnIndex}){
                let cellStyle;

                if(columnIndex === 7){
                    switch (row.auditState) {
                        case '-1':
                            cellStyle = 'color: #808080 !important;';
                            break;
                        case '0':
                            cellStyle = 'color: #e6a23c !important;';
                            break;
                        case '3':
                            cellStyle = 'color: #409eff !important;';
                            break;
                        case '1':
                            cellStyle = 'color: #00FF40 !important;';
                            break;
                        case '2':
                            cellStyle = 'color: #FE2E2E !important;';
                            break;
                        case '4':
                            cellStyle = 'color: #8080FF !important;';
                            break;
                        case '5':
                            cellStyle = 'color: #FE2E2E !important;';
                            break;
                        default:
                            cellStyle = '';
                    }

                    return cellStyle;
                }
            },
            initOption() {
                const paramMap = {
                    'name': 'combo_Info'
                }
                this.$api.courseAdjust.courseAdjust.initOption({
                    data: paramMap
                }).then(response => {
                    this.xnxqInfo = response.data.data.xnxq;
                    this.curterm = response.data.data.curterm;
                    this.queryForm.xnxqbm = response.data.data.curterm;
                    this.exportForm.xnxqbm = response.data.data.curterm;
                    this.adjustReasonInfo = response.data.data.adjustReason;
                    this.userCode = response.data.data.userCode;
                    this.userName = response.data.data.userName;
                    this.userAuth = response.data.data.userAuth;
                    this.auditInfo = response.data.data.auditInfo;
                    this.exportClassInfo = response.data.data.exportClassInfo;
                    this.exportCourseInfo = response.data.data.exportCourseInfo;

                    this.teacherOption();
                    this.siteOption();

                    this.$nextTick().then(() => {
                        this.queryAuditParam();
                    });

                    if(this.curterm=="" || this.curterm==null){
                        this.$alert("当前日期不在排课截止日期到学期结束日期范围内！", "提示", {
                            confirmButtonText: "确定",
                        });
                        return;
                    }

                    this.disabled = true;
                    //alert(JSON.stringify(response.data.data));
                }).catch(error => {
                    console.log(error);
                });
            },
            queryList() {
                this.tableLoading = true;
                this.queryForm.pageNum = this.currentPage;
                this.queryForm.rowNum = this.limit;

                this.$api.courseAdjust.courseAdjust.queryList({
                    data: this.queryForm,
                }).then((response) => {
                    this.total = response.data.data.total;
                    this.tableData = response.data.data.list;
                    this.tableLoading = false;

                    if(this.tableData.length>0){
                        for(let i=0;i<this.tableData.length;i++){
                            if(this.curdForm.id == this.tableData[i].id){
                                //this.auditLevel = this.tableData[0].auditLevel;
                                this.totalAuditLevel = this.tableData[0].totalAuditLevel;
                            }
                        }
                    }

                    $('#loadingMask').hide();
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            teacherOption() {
                const paramMap = {
                    'name': 'combo_Info'
                }
                this.$api.courseAdjust.courseAdjust.teacherOption({
                    data: paramMap
                }).then(response => {
                    this.teacherInfo = response.data.data.teacher;
                    this.tzhteacherInfo = response.data.data.teacher;
                }).catch(error => {
                    console.log(error);
                });
            },
            siteOption() {
                const paramMap = {
                    'classCode': this.curdForm.classCode
                }
                this.$api.courseAdjust.courseAdjust.siteOption({
                    data: paramMap
                }).then(response => {
                    this.tzhsiteInfo = response.data.data.site;
                }).catch(error => {
                    console.log(error);
                });
            },
            majorOption() {
                const paramMap = {
                    'xnxqbm': this.curdForm.xnxqbm,
                    'applyType': this.curdForm.applyType,
                    'applyTeacher': this.curdForm.applyTeacher,
                    'auditState': this.curdForm.auditState,
                }
                this.$api.courseAdjust.courseAdjust.majorOption({
                    data: paramMap
                }).then(response => {
                    this.majorInfo = response.data.data.major;
                    if(this.majorInfo.length==0 && this.curdForm.applyType!='3'){
                        this.$message({
                            message: '申请教师没有排课信息，无法调课！',
                            type: 'warning'
                        });
                    }else{
                        this.disabled_major = false;
                        this.majorholder = '请选择专业';
                    }
                }).catch(error => {
                    console.log(error);
                });
            },
            classOption() {
                const paramMap = {
                    'xnxqbm': this.curdForm.xnxqbm,
                    'applyType': this.curdForm.applyType,
                    'applyTeacher': this.curdForm.applyTeacher,
                    'auditState': this.curdForm.auditState,
                    'majorCode': this.curdForm.majorCode,
                }
                this.$api.courseAdjust.courseAdjust.classOption({
                    data: paramMap
                }).then(response => {
                    this.classInfo = response.data.data.class;
                    this.disabled_class = false;
                    this.classholder = '请选择班级';
                }).catch(error => {
                    console.log(error);
                });
            },
            courseOption() {
                const paramMap = {
                    'xnxqbm': this.curdForm.xnxqbm,
                    'applyType': this.curdForm.applyType,
                    'applyTeacher': this.curdForm.applyTeacher,
                    'auditState': this.curdForm.auditState,
                    'classCode': this.curdForm.classCode,
                }
                this.$api.courseAdjust.courseAdjust.courseOption({
                    data: paramMap
                }).then(response => {
                    this.courseInfo = response.data.data.course;
                    this.disabled_course = false;
                    this.courseholder = '请选择课程';
                }).catch(error => {
                    console.log(error);
                });
            },
            yjhskzcOption(){
                const paramMap = {
                    'xnxqbm': this.curdForm.xnxqbm,
                    'id': this.curdForm.id,
                    'applyType': this.curdForm.applyType,
                    'skjhmxbh': this.curdForm.courseCode,
                    'auditState': this.curdForm.auditState,
                    'editType': this.editType,
                }
                this.$api.courseAdjust.courseAdjust.yjhskzcOption({
                    data: paramMap
                }).then(response => {
                    this.yjhskzcInfo = response.data.data.yjhskzc;
                    if(this.changeFlag == "true" && this.curdForm.applyType != '3'){
                        this.curdForm.yjhskzc = this.yjhskzcInfo[0].comboValue.split(",");
                    }
                    this.yjhxqOption();
                }).catch(error => {
                    console.log(error);
                });
            },
            yjhxqOption(yjhskzc){
                const paramMap = {
                    'xnxqbm': this.curdForm.xnxqbm,
                    'id': this.curdForm.id,
                    'applyType': this.curdForm.applyType,
                    'skjhmxbh': this.curdForm.courseCode,
                    'auditState': this.curdForm.auditState,
                    'editType': this.editType,
                    'yjhskzc': this.curdForm.yjhskzc+'',
                }
                this.$api.courseAdjust.courseAdjust.yjhxqOption({
                    data: paramMap
                }).then(response => {
                    this.yjhxqInfo = response.data.data.yjhxq;
                    if(this.changeFlag == "true"){
                        if(this.yjhxqInfo.length>0){
                            this.curdForm.yjhxq = this.yjhxqInfo[0].comboValue;
                        }else{
                            this.curdForm.yjhxq = "";
                        }
                    }
                    this.yjhsjxlOption();
                }).catch(error => {
                    console.log(error);
                });
            },
            yjhsjxlOption(yjhskzc,yjhxq){
                const paramMap = {
                    'xnxqbm': this.curdForm.xnxqbm,
                    'id': this.curdForm.id,
                    'applyType': this.curdForm.applyType,
                    'skjhmxbh': this.curdForm.courseCode,
                    'auditState': this.curdForm.auditState,
                    'editType': this.editType,
                    'yjhskzc': this.curdForm.yjhskzc+'',
                    'yjhxq': this.curdForm.yjhxq,
                }
                this.$api.courseAdjust.courseAdjust.yjhsjxlOption({
                    data: paramMap
                }).then(response => {
                    this.yjhsjxlInfo = response.data.data.yjhsjxl;
                    if(this.changeFlag == "true"){
                        if(this.yjhsjxlInfo.length>0){
                            this.curdForm.yjhsjxl = this.yjhsjxlInfo[0].comboValue.split(",");
                        }else{
                            this.curdForm.yjhsjxl = '';
                        }
                    }
                    this.teaAndSiteOption();
                }).catch(error => {
                    console.log(error);
                });
            },
            teaAndSiteOption(yjhskzc,yjhxq,yjhsjxl){
               const paramMap = {
                   'xnxqbm': this.curdForm.xnxqbm,
                   'id': this.curdForm.id,
                   'applyType': this.curdForm.applyType,
                   'skjhmxbh': this.curdForm.courseCode,
                   'auditState': this.curdForm.auditState,
                   'editType': this.editType,
                   'yjhskzc': this.curdForm.yjhskzc+'',
                   'yjhxq': this.curdForm.yjhxq,
                   'yjhsjxl': this.curdForm.yjhsjxl+'',
               }
                this.$api.courseAdjust.courseAdjust.teaAndSiteOption({
                    data: paramMap
                }).then(response => {
                    //this.teacherList = response.data.data.tealist;
                    //this.siteList = response.data.data.sitelist;

                    this.sameFlag = response.data.data.flag;
                    if(this.sameFlag == "true"){
                        this.curdForm.yjhskjsbh = response.data.data.teacherCode;
                        this.curdForm.yjhskjsxm = response.data.data.teacherName;
                        this.curdForm.yjhcdbh = response.data.data.siteCode;
                        this.curdForm.yjhcdmc = response.data.data.siteName;
                        if(this.curdForm.applyType != '3'){//不是补课
                            if(this.editType == "new"){
                                this.curdForm.tzhskjsbh = response.data.data.teacherCode;
                                this.curdForm.tzhskjsxm = response.data.data.teacherName;
                                this.curdForm.tzhcdbh = response.data.data.siteCode;
                                this.curdForm.tzhcdmc = response.data.data.siteName;
                            }else{
                                this.curdForm.tzhskjsbh = response.data.data.tzhskjsbh;
                                this.curdForm.tzhskjsxm = response.data.data.tzhskjsxm;
                                this.curdForm.tzhcdbh = response.data.data.tzhcdbh;
                                this.curdForm.tzhcdmc = response.data.data.tzhcdmc;
                            }

                            this.yjhteaList = [];
                            this.tzhteaList = [];
                            this.yjhsiteList = [];
                            this.tzhsiteList = [];
                            var teaid = this.curdForm.yjhskjsbh.split(",");
                            var teaxm = this.curdForm.yjhskjsxm.split(",");
                            for(let i=0;i<teaid.length;i++){
                                this.yjhteaList.push({'value':teaid[i],'name':teaxm[i]});
                            }

                            var siteid = this.curdForm.yjhcdbh.split(",");
                            var sitename = this.curdForm.yjhcdmc.split(",");
                            for(let i=0;i<siteid.length;i++){
                                this.yjhsiteList.push({'value':siteid[i],'name':sitename[i]});
                            }

                            teaid = this.curdForm.tzhskjsbh.split(",");
                            teaxm = this.curdForm.tzhskjsxm.split(",");
                            for(let i=0;i<teaid.length;i++){
                                this.tzhteaList.push({'value':teaid[i],'name':teaxm[i]});
                            }

                            siteid = this.curdForm.tzhcdbh.split(",");
                            sitename = this.curdForm.tzhcdmc.split(",");
                            for(let i=0;i<siteid.length;i++){
                                this.tzhsiteList.push({'value':siteid[i],'name':sitename[i]});
                            }
                        }
                    }else{
                        this.curdForm.yjhskjsxm = "当前选择的课程时间的授课教师不同，无法统一设置。";
                        this.curdForm.yjhcdmc = "当前选择的课程时间的授课地点不同，无法统一设置。";
                    }
                }).catch(error => {
                    console.log(error);
                });
            },
            tzhskzcOption(){
                const paramMap = {
                    'xnxqbm': this.curdForm.xnxqbm,
                }
                this.$api.courseAdjust.courseAdjust.tzhskzcOption({
                    data: paramMap
                }).then(response => {
                    this.tzhskzcInfo = response.data.data.tzhskzc;
                    if(this.changeFlag == "true"){
                        this.curdForm.tzhskzc = this.tzhskzcInfo[0].comboValue.split(",");
                    }
                    this.tzhxqOption();
                }).catch(error => {
                    console.log(error);
                });
            },
            tzhxqOption(){
                const paramMap = {
                    'xnxqbm': this.curdForm.xnxqbm,
                }
                this.$api.courseAdjust.courseAdjust.tzhxqOption({
                    data: paramMap
                }).then(response => {
                    this.tzhxqInfo = response.data.data.tzhxq;
                    if(this.changeFlag == "true"){
                        this.curdForm.tzhxq = this.tzhxqInfo[0].comboValue;
                    }
                    this.tzhsjxlOption();
                }).catch(error => {
                    console.log(error);
                });
            },
            tzhsjxlOption(){
                const paramMap = {
                    'xnxqbm': this.curdForm.xnxqbm,
                }
                this.$api.courseAdjust.courseAdjust.tzhsjxlOption({
                    data: paramMap
                }).then(response => {
                    this.tzhsjxlInfo = response.data.data.tzhsjxl;
                    if(this.changeFlag == "true"){
                        this.curdForm.tzhsjxl = this.tzhsjxlInfo[0].comboValue.split(",");
                    }
                }).catch(error => {
                    console.log(error);
                });
            },
            applyTypeChange(val){
                this.adjustFlag = val;
                this.curdForm.majorCode = '';
                this.curdForm.classCode = '';
                this.curdForm.courseCode = '';

                if(this.userAuth.indexOf('@1@')>-1){
                    this.curdForm.applyTeacher = "";
                    this.disabled_major = true;
                    this.majorholder = '请先选择申请教师';
                }

                this.disabled_class = true;
                this.disabled_course = true;
                this.classholder = '请先选择专业';
                this.courseholder = '请先选择班级';
                this.clearSkzcSjxl();
            },
            applyTeacherChange(){
                this.curdForm.majorCode = '';
                this.curdForm.classCode = '';
                this.curdForm.courseCode = '';
                this.disabled_major = true;
                this.disabled_class = true;
                this.disabled_course = true;
                this.majorholder = '请先选择申请教师';
                this.classholder = '请先选择专业';
                this.courseholder = '请先选择班级';
                this.majorOption();
                this.clearSkzcSjxl();
            },
            applyMajorChange(){
                this.curdForm.classCode = '';
                this.curdForm.courseCode = '';
                this.disabled_class = true;
                this.disabled_course = true;
                this.classholder = '请先选择专业';
                this.courseholder = '请先选择班级';
                this.classOption();
                this.clearSkzcSjxl();
            },
            applyClassChange(val){
                this.curdForm.courseCode = '';
                this.disabled_course = true;
                this.courseholder = '请先选择班级';

                this.courseOption();
                this.siteOption();
                this.clearSkzcSjxl();

                //验证同班级是否存在未审核调课申请
                /* // const paramMap = {
                //     'xnxqbm': this.curdForm.xnxqbm,
                //     'id': this.curdForm.id,
                //     'classCode': val,
                // }
                // this.$api.courseAdjust.courseAdjust.checkUnauditAdjust({
                //     data: paramMap
                // }).then(response => {
                //     let state = response.data.data.state;
                //     if(state == "true"){
                //         this.$message.warning('该班级存在未审核的调课申请，为防止课程冲突，请稍候再申请！');
                //     }else{
                //         this.courseOption();
                //         this.siteOption();
                //         this.clearSkzcSjxl();
                //     }
                // }).catch(error => {
                //     console.log(error);
                // }); */
            },
            applyCourseChange(){
                this.adjustFlag = this.curdForm.applyType;
                this.clearSkzcSjxl();
                //读取当前课程的周次,星期,节次信息
                this.yjhskzcOption();
                this.tzhskzcOption();
            },
            adjustReasonChange(val){
                if(val == '01'){
                    this.uploadButton = true;
                }else{
                    this.uploadButton = false;
                }
            },
            yjhskzcChange(){
                this.changeFlag = "true";
                this.yjhxqOption();
            },
            yjhxqChange(){
                this.changeFlag = "true";
                this.yjhsjxlOption();
            },
            yjhsjxlChange(){
                this.changeFlag = "true";
                this.teaAndSiteOption();
            },
            tzhskzcChange(){
                this.changeFlag = "true";
                //this.tzhxqOption();
            },
            tzhxqChange(){
                this.changeFlag = "true";
                //this.tzhsjxlOption();
            },
            tzhsjxlChange(){
                this.changeFlag = "true";
            },
            teaChange(val,i){
                this.tzhteaList[i].value = val;

                let objtea = {};
                objtea = this.tzhteacherInfo.find((item)=>{
                    return item.comboValue === val;//筛选出匹配数据
                });
                this.tzhteaList[i].name = objtea.teacherName;
            },
            siteChange(val,i){
                this.tzhsiteList[i].value = val;

                let objsite = {};
                objsite = this.tzhsiteInfo.find((item)=>{
                    return item.comboValue === val;//筛选出匹配数据
                });
                this.tzhsiteList[i].name = objsite.siteName;
            },
            clearSkzcSjxl(){
                this.curdForm.yjhskzc = '';
                this.curdForm.yjhxq = '';
                this.curdForm.yjhsjxl = '';
                this.curdForm.yjhskjsbh = '';
                this.curdForm.yjhskjsxm = '';
                this.curdForm.yjhcdbh = '';
                this.curdForm.yjhcdmc = '';

                this.curdForm.tzhskzc = '';
                this.curdForm.tzhxq = '';
                this.curdForm.tzhsjxl = '';
                this.curdForm.tzhskjsbh = '';
                this.curdForm.tzhskjsxm = '';
                this.curdForm.tzhcdbh = '';
                this.curdForm.tzhcdmc = '';
            },
            handleFilter() {
                this.currentPage = 1;
                this.queryList();
            },
            handleReset() {
                this.limit = 10;
                this.currentPage = 1;
                this.queryForm.xnxqbm = null;
                this.queryForm.courseName = null;
                this.queryForm.className = null;
                this.queryForm.applyType = '';
                this.queryForm.auditState = '';
                this.tableLoading = false;
                this.queryList();
            },
            handlePageChange(val) {
                this.currentPage = val;
                this.queryList();
            },
            handleCurrentChange(val) {
               this.selectRowData = val;
            },
            handleSizeChange(val) {
                this.limit = val;
                this.currentPage = 1;
                this.queryList();
            },
            querySearchStu(queryString, cb){
                let students = this.students;
                let results = queryString ? students.filter(this.createFilter(queryString)) : students;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (student) => {
                    return (student.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
                };
            },
            handleSelectStu(item){
                this.curdForm.stuCode = item.stuCode;
                this.curdForm.stuName = item.stuName;
                this.curdForm.oriMajorCode = item.majorCode;
                this.curdForm.oriMajorName = item.majorName;
                this.curdForm.oriClassCode = item.classCode;
                this.curdForm.oriClassName = item.className;
            },
            clearSelectStu(){
                document.activeElement.blur();
            },
            //选择学期
            selectChange(term){
                this.siteOption();
                this.timeslotOption(term);
            },
            rowClickDateTime(row){
                this.selectRowDateTime = row;
            },
            showUpload(){
                if(this.curdForm.id == ''){
                    this.$alert("请先保存申请后再上传附件", "提示", {
                        confirmButtonText: "确定",
                    });
                    return;
                }else{
                    this.attachmentVisible = true;
                }
            },
            clickUpload(){
                this.uploadDialogVisible = true;
            },
            addRec(){
                if(this.curterm == null || this.curterm ==""){
                    this.$message.warning('当前日期不在排课截止日期到学期结束日期范围内，不能进行调课操作。');
                    return;
                }

                //获取学期名称
                let xnxqmc = "";
                let obj = {};
                obj = this.xnxqInfo.find((item)=>{
                    return item.comboValue === this.curterm;//筛选出匹配数据
                });
                xnxqmc = obj.comboName;

                this.dialogTitle = "新建 （" + xnxqmc + "）";
                this.disabled = false;
                this.auditDisabled = false;
                this.dialogVisible = true;
                this.editType = "new";
                this.curdForm.submitState = '0';
                this.curdForm.auditState = "-1";
                this.curdForm.adjustReason = "01";
                this.adjustReasonChange(this.curdForm.adjustReason);
                this.disabled_major = true;
                this.disabled_class = true;
                this.disabled_course = true;
                this.majorholder = '请先选择申请教师';
                this.classholder = '请先选择专业';
                this.courseholder = '请先选择班级';
                this.curdForm.xnxqbm = this.curterm;
                this.changeFlag = "true";

                if(this.userAuth.indexOf('@1@')==-1){
                    this.curdForm.applyTeacher = this.userCode;
                    this.curdForm.applyTeacherName = this.userName;
                    this.applyTeacherChange();
                }

                if(this.$refs['curdForm'] !== undefined){
                    this.$refs['curdForm'].resetFields();
                }
            },
            modRec(rowData) {
                this.selectRowData = rowData;

                if (this.selectRowData == null) {
                    this.$alert("请先选择一条记录", "提示", {
                        confirmButtonText: "确定",
                    });
                    return;
                }

                if(this.editType == "audit"){
                    this.dialogTitle = "审核";
                    this.disabled = false;
                }else if(this.editType == "show"){
                    this.dialogTitle = "详情";
                    this.disabled = false;
                }else{
                    this.dialogTitle = "编辑";
                    this.disabled = false;
                    this.auditDisabled = false;
                    this.operateAreaVisible = true;
                    this.editType = "edit";
                    this.changeFlag = "false";
                }

                this.$nextTick(() => {
                    this.adjustFlag = this.selectRowData.applyType;

                    this.curdForm.id = this.selectRowData.id;
                    this.curdForm.xnxqbm = this.selectRowData.xnxqbm;
                    this.curdForm.xnxqmc = this.selectRowData.xnxqmc;
                    this.curdForm.skjhmxbh = this.selectRowData.skjhmxbh;
                    this.curdForm.applyType = this.selectRowData.applyType;
                    this.curdForm.applyTypeName = this.selectRowData.applyTypeName;
                    this.curdForm.applyTeacher = this.selectRowData.applyTeacher;
                    this.curdForm.applyTeacherName = this.selectRowData.applyTeacherName;

                    this.curdForm.submitState = this.selectRowData.submitState;
                    this.curdForm.auditState = this.selectRowData.auditState;
                    this.majorOption();
                    this.curdForm.majorCode = this.selectRowData.majorCode;
                    this.curdForm.majorName = this.selectRowData.majorName;
                    this.classOption();
                    this.curdForm.classCode = this.selectRowData.classCode;
                    this.curdForm.className = this.selectRowData.className;
                    this.courseOption();
                    this.curdForm.courseCode = this.selectRowData.skjhmxbh;
                    this.curdForm.courseName = this.selectRowData.courseName;
                    this.curdForm.adjustReason = this.selectRowData.adjustReason;
                    this.curdForm.adjustReasonName = this.selectRowData.adjustReasonName;
                    this.adjustReasonChange(this.curdForm.adjustReason);
                    this.curdForm.changeReason = this.selectRowData.changeReason;
                    this.siteOption();

                    this.yjhskzcOption();
                    this.tzhskzcOption();

                    this.curdForm.yjhskzc = this.selectRowData.yjhskzc.split(",");
                    this.curdForm.yjhxq = this.selectRowData.yjhxq;
                    this.curdForm.yjhsjxl = this.selectRowData.yjhsjxl.split(",");

                    this.curdForm.tzhskzc = this.selectRowData.tzhskzc.split(",");
                    this.curdForm.tzhxq = this.selectRowData.tzhxq;
                    this.curdForm.tzhsjxl = this.selectRowData.tzhsjxl.split(",");

                    this.curdForm.yjhskjsbh = this.selectRowData.yjhskjsbh;
                    this.curdForm.yjhskjsxm = this.selectRowData.yjhskjsxm;
                    this.curdForm.yjhcdbh = this.selectRowData.yjhcdbh;
                    this.curdForm.yjhcdmc = this.selectRowData.yjhcdmc;

                    if(this.selectRowData.applyType!='3'){
                        this.curdForm.tzhskjsbh = this.selectRowData.tzhskjsbh;
                        this.curdForm.tzhcdbh = this.selectRowData.tzhcdbh;
                    }
                    this.curdForm.tzhskjsxm = this.selectRowData.tzhskjsxm;
                    this.curdForm.tzhcdmc = this.selectRowData.tzhcdmc;

                    this.curdForm.otherExplain = this.selectRowData.otherExplain;

                    this.curdForm.auditAuth = this.selectRowData.auditAuth;
                    this.curdForm.totalAuditLevel = this.selectRowData.totalAuditLevel;
                    this.totalAuditLevel = this.selectRowData.totalAuditLevel;
                    this.curdForm.auditLevel = this.selectRowData.auditLevel;

                    var teaid = "";
                    var teaname = "";
                    var siteid = "";
                    var sitename = "";
                    if(this.selectRowData.applyType=='1'){
                        siteid = this.curdForm.yjhcdbh.split(",");
                        sitename = this.curdForm.yjhcdmc.split(",");
                        for(let i=0;i<siteid.length;i++){
                            this.yjhsiteList.push({'value':siteid[i],'name':sitename[i]});
                        }

                        siteid = this.curdForm.tzhcdbh.split(",");
                        sitename = this.curdForm.tzhcdmc.split(",");
                        for(let i=0;i<siteid.length;i++){
                            this.tzhsiteList.push({'value':siteid[i],'name':sitename[i]});
                        }
                    }else if(this.selectRowData.applyType=='4'){
                        teaid = this.curdForm.yjhskjsbh.split(",");
                        teaname = this.curdForm.yjhskjsxm.split(",");
                        for(let i=0;i<teaid.length;i++){
                            this.yjhteaList.push({'value':teaid[i],'name':teaname[i]});
                        }

                        teaid = this.curdForm.tzhskjsbh.split(",");
                        teaname = this.curdForm.tzhskjsxm.split(",");
                        for(let i=0;i<teaid.length;i++){
                            this.tzhteaList.push({'value':teaid[i],'name':teaname[i]});
                        }


                        siteid = this.curdForm.yjhcdbh.split(",");
                        sitename = this.curdForm.yjhcdmc.split(",");
                        for(let i=0;i<siteid.length;i++){
                            this.yjhsiteList.push({'value':siteid[i],'name':sitename[i]});
                        }

                        siteid = this.curdForm.tzhcdbh.split(",");
                        sitename = this.curdForm.tzhcdmc.split(",");
                        for(let i=0;i<siteid.length;i++){
                            this.tzhsiteList.push({'value':siteid[i],'name':sitename[i]});
                        }
                    }else if(this.selectRowData.applyType=='2'){

                    }else if(this.selectRowData.applyType=='3'){
                        this.curdForm.tzhskjsbh = this.selectRowData.tzhskjsbh.split(",");
                        this.curdForm.tzhcdbh = this.selectRowData.tzhcdbh.split(",");
                    }

                });

                this.queryAttachmentList();

                this.dialogVisible = true;
            },
            saveInfo(){
                this.curdForm.submitState = '0';
                $('#loadingMask').show();
                this.saveRec();
            },
            saveRec() {
                this.formSubmiting = true;

                this.$refs['curdForm'].validate((valid) => {
                    if (valid) {
                        if(this.curdForm.applyType == ''){
                            this.$message.error('请选择申请类型');
                            $('#loadingMask').hide();
                            return;
                        }
                        if(this.curdForm.applyType!="3"){//不是补课
                            if(this.userAuth.indexOf('@1@')>-1){//admin
                                if(this.editType=="new"){
                                    if(this.curdForm.applyTeacher==""){
                                        this.$message.error("请选择申请教师");
                                        $('#loadingMask').hide();
                                        return;
                                    }
                                }
                            }
                        }
                        if(this.curdForm.majorCode == ''){
                            this.$message.error('请选择专业');
                            $('#loadingMask').hide();
                            return;
                        }
                        if(this.curdForm.classCode == ''){
                            this.$message.error('请选择班级');
                            $('#loadingMask').hide();
                            return;
                        }
                        if(this.curdForm.courseCode == ''){
                            this.$message.error('请选择课程');
                            $('#loadingMask').hide();
                            return;
                        }

                        if(this.curdForm.applyType=="3"){
                            if(this.curdForm.tzhskzc == ''){
                                this.$message.error('请选择周数');
                                $('#loadingMask').hide();
                                return;
                            }
                            if(this.curdForm.tzhxq == ''){
                                this.$message.error('请选择星期');
                                $('#loadingMask').hide();
                                return;
                            }
                            if(this.curdForm.tzhsjxl == ''){
                                this.$message.error('请选择节数');
                                $('#loadingMask').hide();
                                return;
                            }
                        }else{
                            if(this.curdForm.yjhskzc == ''){
                                this.$message.error('请选择周数');
                                $('#loadingMask').hide();
                                return;
                            }
                            if(this.curdForm.yjhxq == ''){
                                this.$message.error('请选择星期');
                                $('#loadingMask').hide();
                                return;
                            }
                            if(this.curdForm.yjhsjxl == ''){
                                this.$message.error('请选择节数');
                                $('#loadingMask').hide();
                                return;
                            }
                        }

                        if(this.curdForm.submitState=="1" && this.fileTableData.length < 1 && this.curdForm.adjustReason=="01"){
                            this.$message.error('请上传调课原因附件');
                            $('#loadingMask').hide();
                            return;
                        }

                        if(this.curdForm.applyType == "1"){//调课
                            this.curdForm.tzhskjsbh = this.curdForm.yjhskjsbh;
                            this.curdForm.tzhskjsxm = this.curdForm.yjhskjsxm;

                            let cdbh = "";
                            let cdmc = "";
                            for(let i=0;i<this.tzhsiteList.length;i++){
                                cdbh += this.tzhsiteList[i].value + ",";
                                cdmc += this.tzhsiteList[i].name + ",";
                            }
                            if(cdbh!=""){
                                this.curdForm.tzhcdbh = cdbh.substring(0,cdbh.length-1);
                                this.curdForm.tzhcdmc = cdmc.substring(0,cdmc.length-1);
                            }
                        }else if(this.curdForm.applyType == "4"){//代课
                            this.curdForm.tzhskzc = this.curdForm.yjhskzc;
                            this.curdForm.tzhxq = this.curdForm.yjhxq;
                            this.curdForm.tzhsjxl = this.curdForm.yjhsjxl;

                            let jsbh = "";
                            let jsmc = "";
                            for(let i=0;i<this.tzhteaList.length;i++){
                                jsbh += this.tzhteaList[i].value + ",";
                                jsmc += this.tzhteaList[i].name + ",";
                            }
                            if(jsbh!=""){
                                jsbh = jsbh.substring(0,jsbh.length-1);
                                jsmc = jsmc.substring(0,jsmc.length-1);
                                this.curdForm.tzhskjsbh = jsbh;
                                this.curdForm.tzhskjsxm = jsmc;
                            }

                            let cdbh = "";
                            let cdmc = "";
                            for(let i=0;i<this.tzhsiteList.length;i++){
                                cdbh += this.tzhsiteList[i].value + ",";
                                cdmc += this.tzhsiteList[i].name + ",";
                            }
                            if(cdbh!=""){
                                this.curdForm.tzhcdbh = cdbh.substring(0,cdbh.length-1);
                                this.curdForm.tzhcdmc = cdmc.substring(0,cdmc.length-1);
                            }

                            if(this.curdForm.yjhskjsbh == jsbh){
                               this.$message.error('代课教师相同，无法保存');
                               $('#loadingMask').hide();
                               return;
                            }

                        }else if(this.curdForm.applyType == "3"){//补课
                            if(this.curdForm.tzhskjsbh == ''){
                                this.$message.error('请选择授课教师');
                                $('#loadingMask').hide();
                                return;
                            }
                            if(this.curdForm.tzhcdbh == ''){
                                this.$message.error('请选择授课地点');
                                $('#loadingMask').hide();
                                return;
                            }

                            this.curdForm.yjhskzc = '';
                            this.curdForm.yjhxq = '';
                            this.curdForm.yjhsjxl = '';
                            this.curdForm.yjhskjsbh = '';
                            this.curdForm.yjhskjsxm = '';
                            this.curdForm.yjhcdbh = '';
                            this.curdForm.yjhcdmc = '';

                            let jsbh = (this.curdForm.tzhskjsbh+'').split(",");
                            let cdbh = (this.curdForm.tzhcdbh+'').split(",");
                            let jsmc = "";
                            let cdmc = "";

                            for(let i=0;i<jsbh.length;i++){
                                let objtea = {};
                                objtea = this.tzhteacherInfo.find((item)=>{
                                    return item.comboValue === jsbh[i];//筛选出匹配数据
                                });
                                jsmc += objtea.teacherName+",";
                            }
                            if(jsmc!=""){
                                this.curdForm.tzhskjsxm = jsmc.substring(0,jsmc.length-1);
                            }

                            for(let i=0;i<cdbh.length;i++){
                                let objsite = {};
                                objsite = this.tzhsiteInfo.find((item)=>{
                                    return item.comboValue === cdbh[i];//筛选出匹配数据
                                });
                                cdmc += objsite.siteName+",";
                            }
                            if(cdmc!=""){
                                this.curdForm.tzhcdmc = cdmc.substring(0,cdmc.length-1);
                            }
                        }else if(this.curdForm.applyType == "2"){//停课
                            this.curdForm.tzhskzc = '';
                            this.curdForm.tzhxq = '';
                            this.curdForm.tzhsjxl = '';
                            this.curdForm.tzhskjsbh = '';
                            this.curdForm.tzhskjsxm = '';
                            this.curdForm.tzhcdbh = '';
                            this.curdForm.tzhcdmc = '';
                        }

                        if(this.curdForm.applyType=="1"){
                            if(this.curdForm.yjhskzc.length != this.curdForm.tzhskzc.length){
                                this.$message.error('原计划与调整后周次数量不相等，无法保存');
                                $('#loadingMask').hide();
                                return;
                            }

                            if(this.curdForm.yjhsjxl.length != this.curdForm.tzhsjxl.length){
                                this.$message.error('原计划与调整后节数数量不相等，无法保存');
                                $('#loadingMask').hide();
                                return;
                            }

                            if(this.curdForm.yjhskzc == this.curdForm.tzhskzc+'' && this.curdForm.yjhxq == this.curdForm.tzhxq &&
                               this.curdForm.yjhsjxl == this.curdForm.tzhsjxl+'' && this.curdForm.yjhcdbh == this.curdForm.tzhcdbh){
                               this.$message.error('调课时间和场地相同，无法保存');
                               $('#loadingMask').hide();
                               return;
                            }
                        }

                        this.showLoadingMask("正在保存中，请稍候");

                        const paramMap = {
                            'id': this.curdForm.id,
                            'xnxqbm':this.curdForm.xnxqbm,
                            'skjhmxbh':this.curdForm.skjhmxbh,
                            'applyType':this.curdForm.applyType,
                            'applyTeacher':this.curdForm.applyTeacher,
                            'majorCode':this.curdForm.majorCode,
                            'classCode':this.curdForm.classCode,
                            'courseCode':this.curdForm.courseCode,
                            'adjustReason':this.curdForm.adjustReason,
                            'changeReason':this.curdForm.changeReason,
                            'yjhskzc':this.curdForm.yjhskzc+'',
                            'yjhxq':this.curdForm.yjhxq,
                            'yjhsjxl':this.curdForm.yjhsjxl+'',
                            'yjhskjsbh':this.curdForm.yjhskjsbh,
                            'yjhskjsxm':this.curdForm.yjhskjsxm,
                            'yjhcdbh':this.curdForm.yjhcdbh,
                            'yjhcdmc':this.curdForm.yjhcdmc,
                            'tzhskzc':this.curdForm.tzhskzc+'',
                            'tzhxq':this.curdForm.tzhxq,
                            'tzhsjxl':this.curdForm.tzhsjxl+'',
                            'tzhskjsbh':this.curdForm.tzhskjsbh+'',
                            'tzhskjsxm':this.curdForm.tzhskjsxm,
                            'tzhcdbh':this.curdForm.tzhcdbh+'',
                            'tzhcdmc':this.curdForm.tzhcdmc,
                            'otherExplain':this.curdForm.otherExplain,
                            'editType': this.editType,
                            'submitState': this.curdForm.submitState,
                        };
                        this.$api.courseAdjust.courseAdjust.saveAdjust({
                            data: paramMap,
                        }).then((response) => {
                            let state = response.data.data.state;
                            let msg = response.data.data.msg;

                            if (state == 'Success') {
                                this.$notify({
                                    title: "成功",
                                    message: msg ? msg : "保存成功",
                                    type: "success",
                                    duration: 1500,
                                });

                                if(this.editType=="new" && this.curdForm.id==''){
                                    let bh = response.data.data.bh;
                                    this.curdForm.id = bh;
                                }
                                if(this.curdForm.submitState == '1'){
                                    this.dialogVisible = false;
                                }
                                this.currentPage = 1;
                                this.limit = 10;
                                this.queryList();
                            }else{
                                if(state == 'unaudit'){
                                    this.$message.warning(msg);
                                }else{
                                    this.$notify({
                                        title: "失败",
                                        message: msg ? msg : '保存失败',
                                        type: "error",
                                        duration: 3000,
                                    });
                                }
                                $('#loadingMask').hide();
                            }
                            this.closeLoadingMask();
                        }).catch((error) => {
                            this.$notify({
                                title: "错误",
                                message: error,
                                type: "error",
                                duration: 3000,
                            });
                            this.closeLoadingMask();
                        });
                    } else {
                        return false;
                    }
                });

                this.formSubmiting = false;
            },
            submitRec(){
                confirmMsg('提交后将无法再修改调课信息，是否继续？').then(() => {
                    this.curdForm.submitState = '1';
                    $('#loadingMask').show();
                    this.saveRec();
                });
            },
            delRec(rowData){
                confirmMsg('是否确定要删除该申请？').then(() => {
                    this.curdForm.id = rowData.id;

                    this.$api.courseAdjust.courseAdjust.delApply({
                        data: this.curdForm,
                    }).then((response) => {
                        let state = response.data.data.state;

                        if (state == 'Success') {
                            this.$notify({
                                title: "成功",
                                message: "删除成功",
                                type: "success",
                                duration: 1500,
                            });

                            this.currentPage = 1;
                            this.limit = 10;
                            this.queryList();
                        }else{
                            this.$notify({
                                title: "失败",
                                message: "删除失败",
                                type: "error",
                                duration: 3000,
                            });
                        }
                    }).catch((error) => {
                        this.$notify({
                            title: "错误",
                            message: error,
                            type: "error",
                            duration: 3000,
                        });
                    });
                });
            },
            closeDialog() {
                this.curdForm.id = '';
                this.curdForm.xnxqbm = '';
                this.curdForm.xnxqmc = '';
                this.curdForm.applyType = '1';
                this.curdForm.applyTeacher = '';
                this.curdForm.majorCode = '';
                this.curdForm.classCode = '';
                this.curdForm.courseCode = '';
                this.curdForm.applyTypeName = '';
                this.curdForm.applyTeacherName = '';
                this.curdForm.majorName = '';
                this.curdForm.className = '';
                this.curdForm.courseName = '';
                this.curdForm.adjustReason = '';
                this.curdForm.adjustReasonName = '';
                this.curdForm.changeReason = '';

                this.curdForm.yjhskzc = '';
                this.curdForm.yjhxq = '';
                this.curdForm.yjhsjxl = '';
                this.curdForm.yjhskjsbh = '';
                this.curdForm.yjhskjsxm = '';
                this.curdForm.yjhcdbh = '';
                this.curdForm.yjhcdmc = '';

                this.curdForm.tzhskzc = '';
                this.curdForm.tzhxq = '';
                this.curdForm.tzhsjxl = '';
                this.curdForm.tzhskjsbh = '';
                this.curdForm.tzhskjsxm = '';
                this.curdForm.tzhcdbh = '';
                this.curdForm.tzhcdmc = '';

                this.curdForm.otherExplain = '';
                this.curdForm.submitState = '';
                this.curdForm.auditState = '';
                this.curdForm.auditLevel = '';
                this.curdForm.auditAuth = '';
                this.curdForm.totalAuditLevel = '';

                this.disabled = true;
                this.dialogVisible = false;
                this.editType = null;

                this.yjhteaList = [];
                this.yjhsiteList = [];
                this.tzhteaList = [];
                this.tzhsiteList = [];
                this.adjustFlag = "";
                this.changeFlag = "false";
            },
            showDetailInfo(rowData){
                this.selectRowData = rowData;
                this.detailDialogTitle = '详情';
                this.detailDialogTop = '250px';
                this.editType = "show";
                this.auditDisabled = true;
                this.operateAreaVisible = false;
                this.modRec(rowData);
            },
            //查询附件信息
            queryAttachmentList(){
                this.fileTableLoading = true;
                let code = "";
                if(this.editType == "new"){
                    code = this.curdForm.id;
                }else{
                    code = this.selectRowData.id;
                }

                this.$api.courseAdjust.courseAdjust.attachmentList({
                    data: { designCode: code },
                }).then((response) => {
                    this.fileTableData = response.data.data.list;
                    this.fileTableLoading = false;
                }).catch((error) => {
                    this.fileTableLoading = false;
                    console.log(error);
                });
            },
            //http-request上传方法（未使用）
            getFile(fileObj) {
                this.file = fileObj.file;
                //this.handleUpload(fileObj);
            },
            //当上传文件有变更时
            onChangeFile(file, fileList) {
                //文件类型限制
                let fileTypeArray = [];
                fileTypeArray.push('txt','doc','docx','xls','xlsx','pdf','ppt','pptx');//文本文件
                fileTypeArray.push('jpg','jpeg','png','gif');//图片
                fileTypeArray.push('mp3');//音频
                fileTypeArray.push('mp4');//视频
                let suffix = file.name.substring(file.name.lastIndexOf(".") + 1, file.name.length).toLowerCase();
                //文件大小限制
                const sizeLimit = this.fileSizeLimit * 1024 * 1024;

                //判断文件类型及大小是否符合要求
                if (fileTypeArray.indexOf(suffix) < 0 || file.size > sizeLimit) {
                    this.$message({
                        message: '不符合要求的文件已自动过滤',
                        type: 'error'
                    });

                    let index = fileList.findIndex( fileItem => {
                        return fileItem.uid === file.uid
                    });
                    fileList.splice(index, 1); //从上传文件列表删除当前选中文件
                } else {
                    this.fileList = [];
                    this.fileList = fileList;
                }
            },
            //上传文件
            handleUpload() {
                /* let repeatFlag = false;
                for(let i=0; i<this.fileList.length; i++){
                    for(let j=0; j<this.fileTableData.length; j++){
                        if(this.fileList[i].name == this.fileTableData[j].fileName + '.' + this.fileTableData[j].fileType){
                            repeatFlag = true;
                        }
                    }
                }
                if(repeatFlag){
                    confirmMsg('存在相同名称的文件，上传将覆盖原文件，是否确定上传？').then(() => {
                        this.uploadFile();
                    });

                    return;
                } */

                if(this.fileList.length === 0){
                    this.$message({
                        message: '请先选择上传的文件',
                        type: 'warning'
                    });

                    return;
                }

                this.uploadFile();
            },
            uploadFile(){
                const loading = this.$loading({
                    lock: true,
                    text: '文件上传中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                //添加参数
                var formData = new FormData();
                for (let i=0; i<this.fileList.length; i++) {
                    formData.append("files", this.fileList[i].raw);
                }
                formData.append("designCode", this.curdForm.id);

                this.$api.courseAdjust.courseAdjust.uploadMultiFile({
                    data: formData,
                }).then(response => {
                    if (response.data.data.state == "Success") {
                        showNotify('成功', '上传成功', 'success', 1500);

                        this.uploadDialogVisible = false;
						this.fileList = [];
                        this.$refs.uploadFile.clearFiles(); //把之前上传的清空
                        this.queryAttachmentList();
                    } else {
                        showNotify('失败', '上传失败', 'error', 3000);
                    }

                    loading.close();
                }).catch(error => {
                    showNotify('错误', error, 'error', 3000);
					this.fileList = [];
                    this.$refs.uploadFile.clearFiles(); //把之前上传的清空
                    loading.close();
                });
            },
            handleRemove(file, fileList) {
                //console.log(file,fileList);
                this.fileList = [];
                this.fileList = fileList;
            },
            closeAttachDialog(){
                this.attachmentVisible = false;
            },
            closeUploadDialog() {
                this.uploadDialogVisible = false;
				this.fileList = [];
                this.$refs.uploadFile.clearFiles();
            },
            handleExceed(files, fileList) {
                this.$message.warning(`每次上传限制最多选择10个文件`);
            },
            // 文件上传成功时的函数
            handleFilUploadSuccess(res, file, fileList) {
                // console.log(res, file, fileList)
                this.$message.success("上传成功")
            },
            confirmDelFile() {
                if (this.$refs.multipleTable.selection.length == 0) {
                    this.$message({
                        title: '提示',
                        message: '请选择要删除的附件！',
                        type: 'warning',
                        duration: 2000,
                    });
                    return;
                }

                confirmMsg('此操作将永久删除附件信息, 是否继续?').then(() => {
                    this.delFile();
                });
            },
            delFile(){
                let selectArray = this.$refs.multipleTable.selection;
                let selections = "";
                for (let i=0; i<selectArray.length; i++) {
                    selections += selectArray[i].id + ",";
                }
                if (selections.length > 0) {
                    selections = selections.substring(0, selections.length - 1);
                }

                this.$api.courseAdjust.courseAdjust.delFile({
                    data: { id:selections }
                }).then(response => {
                    let state = response.data.data.state;

                    if (state == 'Success') {
                        showNotify('成功', '删除成功', 'success', 1500);
                        this.queryAttachmentList();
                    }else{
                        showNotify('失败', '删除失败', 'error', 3000);
                    }
                }).catch(error => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            showAttachment(rowData){
                this.fileInfo.name = rowData.fileName;
                this.fileInfo.type = rowData.fileType;
                this.fileInfo.url = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi + rowData.previewPath;
                this.fileName = rowData.fileName + '.' + rowData.fileType;
                this.previewerVisible = true;
            },
            downloadAttachment(rowData){
                const fileUrl = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi + rowData.filePath;
                let exist = this.isExistFile(fileUrl);
                if (exist) {
                    this.downloadFile(fileUrl, rowData.fileName+'.'+rowData.fileType);
                } else {
                    showNotify('错误', '文件不存在，如有疑问请联系管理员！', 'error', 3000);
                }
            },
            downloadFile(url, fileName) {
                let x = new XMLHttpRequest();
                x.open("GET", url, true);
                x.responseType = 'blob';
                x.onload = function(e) {
                    var url = window.URL.createObjectURL(x.response)
                    var a = document.createElement('a');
                    a.href = url
                    a.download = fileName;
                    a.click()
                }
                x.send();
            },
            isExistFile(url) {
                if (url == null || url == undefined || url == "") {
                    return false;
                }
                let xmlhttp;
                if (window.XMLHttpRequest) {
                    xmlhttp = new XMLHttpRequest();
                } else {
                    xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
                }
                xmlhttp.open("GET", url, false);
                xmlhttp.send();
                if (xmlhttp.readyState == 4) {
                    if (xmlhttp.status == 200) return true;
                    //url存在
                    else if (xmlhttp.status == 404) return false;
                    //url不存在
                    else return false; //其他状态
                }
            },
            //查询审核调用参数
            queryAuditParam(){
                const pageName = this.$route.path.substring(this.$route.path.lastIndexOf("/")+1);

                this.$api.common.audit.auditParam({
                    data: { pageName: pageName },
                }).then((res) => {
                    // this.auditParam = res.data.data.auditParam;
                    // this.queryForm.itemCode = this.auditParam;
                    this.auditParam = "TKSQ";
                    this.queryForm.itemCode = "TKSQ";
                    this.queryList();
                }).catch((err) => {
                    console.log(err);
                });
            },
            auditRec(rowData){
                this.timer = new Date().getTime();
                this.selectRowData = rowData;
                this.dialogTitle = '审核';
                this.dialogVisible = true;
                this.operateAreaVisible = false;
                this.applyused = true;

                this.xgbh = rowData.id;
                this.auditDisabled = true;
                this.editType = "audit";
                this.modRec(rowData);
                this.$nextTick().then(() => {
                    this.checkApplyUsed();
                });
            },
            //验证教师和场地是否已被使用
            checkApplyUsed(){
                this.showLoadingMask("课程表验证中，请稍候");

                const paramMap = {
                    'id': this.curdForm.id,
                    'xnxqbm':this.curdForm.xnxqbm,
                    'skjhmxbh':this.curdForm.skjhmxbh,
                    'applyType':this.curdForm.applyType,
                    'applyTeacher':this.curdForm.applyTeacher,
                    'majorCode':this.curdForm.majorCode,
                    'classCode':this.curdForm.classCode,
                    'courseCode':this.curdForm.courseCode,
                    'yjhskzc':this.curdForm.yjhskzc+'',
                    'yjhxq':this.curdForm.yjhxq,
                    'yjhsjxl':this.curdForm.yjhsjxl+'',
                    'yjhskjsbh':this.curdForm.yjhskjsbh,
                    'yjhskjsxm':this.curdForm.yjhskjsxm,
                    'yjhcdbh':this.curdForm.yjhcdbh,
                    'yjhcdmc':this.curdForm.yjhcdmc,
                    'tzhskzc':this.curdForm.tzhskzc+'',
                    'tzhxq':this.curdForm.tzhxq,
                    'tzhsjxl':this.curdForm.tzhsjxl+'',
                    'tzhskjsbh':this.curdForm.tzhskjsbh+'',
                    'tzhskjsxm':this.curdForm.tzhskjsxm,
                    'tzhcdbh':this.curdForm.tzhcdbh+'',
                    'tzhcdmc':this.curdForm.tzhcdmc,
                    'editType': this.editType,
                    'submitState': this.curdForm.submitState,
                };
                this.$api.courseAdjust.courseAdjust.checkApplyUsed({
                    data: paramMap,
                }).then((response) => {
                    let state = response.data.data.state;
                    let msg = response.data.data.msg;

                    if (state == 'Success') {
                        this.applyused = false;
                        this.closeLoadingMask();
                    }else{
                        this.$confirm(msg,'提示',{
                            confirmButtonText: '驳回',
                            cancelButtonText: '取消',
                            customClass: 'confirm-box',
                            type: 'warning'
                        }).then(() => {
                            const paramMap = {
                                'relatedCode': this.curdForm.id,
                                'auditState': "2",//驳回
                                'auditLevel': this.curdForm.auditLevel,
                                'itemCode': this.auditParam,
                                'opinion': msg,
                            }
                            this.$api.courseAdjust.courseAdjust.auditReject({
                                data: paramMap,
                            }).then((response) => {
                                let state = response.data.data.state;
                                if(state == 'Success'){
                                    this.$notify({
                                        title: "成功",
                                        message: "审核成功",
                                        type: "success",
                                        duration: 1500,
                                    });
                                    this.dialogVisible = false;
                                    this.queryList();
                                }else{
                                    this.$notify({
                                        title: "失败",
                                        message: "审核失败",
                                        type: "error",
                                        duration: 1500,
                                    });
                                }
                            }).catch((err) => {
                                console.log(err);
                            });
                        });
                        this.applyused = true;
                        this.closeLoadingMask();
                    }
                }).catch((error) => {
                    this.$notify({
                        title: "错误",
                        message: error,
                        type: "error",
                        duration: 3000,
                    });
                    this.applyused = false;
                    this.closeLoadingMask();
                });
            },
            auditOption(){
                this.detailDialogTitle = this.numarray[parseInt(this.curdForm.auditLevel)-1]+'级审核';
                this.detailDialogTop = '250px';
                this.detailDialogVisible = true;
                this.auditAreaVisible = true;
            },
            //审核后回调函数
            auditCallback(auditInfo){
                this.detailDialogVisible = false;
                this.dialogVisible = false;
                this.auditAreaVisible = false;
                if(auditInfo.auditLevel==this.totalAuditLevel && auditInfo.auditState=="1"){//最后一级审核通过
                    $('#loadingMask').show();
                    this.updateApplyState(auditInfo,"last",auditInfo.auditLevel);
                }else if(auditInfo.auditState=="2"){//审核驳回
                    this.updateApplyState(auditInfo,auditInfo.auditState,auditInfo.auditLevel);
                }else{//非最后一级审核通过
                    this.updateApplyState(auditInfo,auditInfo.auditState,auditInfo.auditLevel);
                }
            },
            //显示审核详情列表
            showAuditList(row) {
                this.$api.courseAdjust.courseAdjust.queryAuditFlow({
                    data: {
                        itemCode: this.queryForm.itemCode,
                        relatedCode: row.id,
                        auditState: row.auditState,
                        auditLevel: row.auditLevel,
                        courseDept: row.xbdm,
                    },
                }).then((res) => {
                    if (res.data.data.state == 'success') {
                        this.auditFlowInfo = res.data.data.auditFlowInfo;
                    }else{
                        this.auditFlowInfo = null;
                    }
            
                    this.selectRowData = row;
                    this.auditListDialogVisible = true;
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            updateApplyState(auditInfo,level,auditLevel){
                const paramMap = {
                    'id': auditInfo.relatedCode,
                    'auditState': auditInfo.auditState,
                    'auditLevel': auditLevel,
                    'level': level,
                    'classCode': this.curdForm.classCode,
                    'xnxqbm': this.curdForm.xnxqbm,
                }
                this.$api.courseAdjust.courseAdjust.updateAuditState({
                    data: paramMap,
                }).then((response) => {
                    let state = response.data.data.state;
                    if(state == 'fail'){
                        this.$notify({
                            title: "失败",
                            message: "审核状态更新失败",
                            type: "error",
                            duration: 3000,
                        });
                    }
                    this.queryList();
                }).catch((error) => {
                    this.$notify({
                        title: "错误",
                        message: error,
                        type: "error",
                        duration: 3000,
                    });
                });
            },
            singleTimeTable(){
                if(this.curdForm.courseCode == ''){
                    this.$message.error('请先选择课程');
                    return;
                }
                if(this.curdForm.yjhxq == ''){
                    this.$message.error('请选择原计划星期');
                    $('#loadingMask').hide();
                    return;
                }
                if(this.curdForm.yjhsjxl == ''){
                    this.$message.error('请选择原计划节数');
                    $('#loadingMask').hide();
                    return;
                }

                this.initBlankTimetable();
                this.tkjcOption();
                this.singleTimeTableVisible = true;
                //this.queryClassTimetable();//填充课表
            },
            initBlankTimetable() {
                this.$api.timetableManage.common.baseParam({
                    data: {
                        semesterCode: this.curdForm.xnxqbm,
                    },
                }).then((res) => {
                    this.weekDayNum = parseInt(res.data.data.baseParam.weekDayNum, 10);
                    this.weekDayName = res.data.data.baseParam.weekDayName.split(',');
                    this.forenoonNum = parseInt(res.data.data.baseParam.forenoonNum, 10);
                    this.noonNum = parseInt(res.data.data.baseParam.noonNum, 10);
                    this.afternoonNum = parseInt(res.data.data.baseParam.afternoonNum, 10);
                    this.eveningNum = parseInt(res.data.data.baseParam.eveningNum, 10);
                    const timeQuantumArray = res.data.data.baseParam.timeQuantum.split(',');
                    const _this = this;
                    this.timeQuantum = new Array();
                    timeQuantumArray.forEach(element => {
                        _this.timeQuantum.push(element.split('@')[1]);
                    });
                    this.cellContent = new Array(this.weekDayNum * parseInt(res.data.data.baseParam.totalNum,
                        10));
                }).catch((err) => {
                    console.log(err);
                });
            },
            tkjcOption() {
                //原计划时间序列combobox
                this.tkjcInfo = [];
                var yjhxq = this.curdForm.yjhxq;
                var yjhjc = this.curdForm.yjhsjxl;
                for(var i=0;i<yjhjc.length;i++){
                    this.tkjcInfo.push({"comboValue":(yjhxq+yjhjc[i]),"comboName":("周"+this.weekarray[parseInt(yjhxq,10)-1]+" 第"+parseInt(yjhjc[i],10)+"节 ")});
                }
                this.tkjc = this.tkjcInfo[0].comboValue;
                this.queryClassTimetable(yjhxq+yjhjc[0]);
            },
            queryClassTimetable(val) {
                const paramMap = {
                    'classCode': this.curdForm.classCode,
                    'semesterCode': this.curdForm.xnxqbm,
                    'weekNum': this.curdForm.tzhskzc+'',
                }
                this.$api.courseAdjust.courseAdjust.queryclass({
                    data: paramMap,
                }).then((response) => {
                    this.timetableInfo = response.data.data.timetable.cellList;
                    this.selectCell(val);
                    this.parseTimetableInfo(this.timetableInfo);
                }).catch(error => {
                    console.log(error);
                });
            },
            parseTimetableInfo(timetableInfo) {
                const _this = this;

                timetableInfo.forEach((cell, index) => {
                    let tempCourseName = '';
                    if (cell.courseName != null) {
                        tempCourseName = cell.courseName;
                        if (tempCourseName.length > 13) {
                            tempCourseName = tempCourseName.substring(0, 10) + '……';
                        }
                        if (cell.weekNum != null) tempCourseName += "<br/>" + cell.weekNum;
                    }

                    document.getElementById('cell_' + index).innerHTML = tempCourseName;
                    _this.cellContent[index] = tempCourseName;
                });

                this.timetableLoading = false;
            },
            tkjcChange(val){
                //查询可以互换的位置
                this.selectCell(val);
            },
            selectCell(sjxl){
                //$('.tdcell').css('background-color', '#FFFFFF');
                if(sjxl!=""){
                    $('#loadingMask_kb').show();

                    if(this.curdForm.applyType == ''){
                        this.$message.error('请选择申请类型');
                        $('#loadingMask_kb').hide();
                        return;
                    }

                    //调课
                    if(this.curdForm.applyType == '1'){
                        if(this.curdForm.majorCode == ''){
                            this.$message.error('请选择专业');
                            $('#loadingMask_kb').hide();
                            return;
                        }
                        if(this.curdForm.classCode == ''){
                            this.$message.error('请选择班级');
                            $('#loadingMask_kb').hide();
                            return;
                        }
                        if(this.curdForm.courseCode == ''){
                            this.$message.error('请选择课程');
                            $('#loadingMask_kb').hide();
                            return;
                        }

                        if(this.curdForm.tzhskzc == ''){
                            this.$message.error('请选择周数');
                            $('#loadingMask_kb').hide();
                            return;
                        }
                        if(this.curdForm.tzhxq == ''){
                            this.$message.error('请选择星期');
                            $('#loadingMask_kb').hide();
                            return;
                        }
                        if(this.curdForm.tzhsjxl == ''){
                            this.$message.error('请选择节数');
                            $('#loadingMask_kb').hide();
                            return;
                        }


                        if(this.curdForm.applyType=="1"){
                            if(this.curdForm.yjhskzc.length != this.curdForm.tzhskzc.length){
                                this.$message.error('原计划与调整后周次数量不相等');
                                $('#loadingMask_kb').hide();
                                return;
                            }

                            if(this.curdForm.yjhsjxl.length != this.curdForm.tzhsjxl.length){
                                this.$message.error('原计划与调整后节数数量不相等');
                                $('#loadingMask_kb').hide();
                                return;
                            }
                        }
                    }

                    //验证可以互换的位置
                    const paramMap = {
                        'id': this.curdForm.id,
                        'xnxqbm':this.curdForm.xnxqbm,
                        'skjhmxbh':this.curdForm.skjhmxbh,
                        'applyType':this.curdForm.applyType,
                        'applyTeacher':this.curdForm.applyTeacher,
                        'majorCode':this.curdForm.majorCode,
                        'classCode':this.curdForm.classCode,
                        'courseCode':this.curdForm.courseCode,
                        'adjustReason':this.curdForm.adjustReason,
                        'changeReason':this.curdForm.changeReason,
                        'yjhskzc':this.curdForm.yjhskzc+'',
                        'yjhxq':this.curdForm.yjhxq,
                        'yjhsjxl':this.curdForm.yjhsjxl+'',
                        'yjhskjsbh':this.curdForm.yjhskjsbh,
                        'yjhskjsxm':this.curdForm.yjhskjsxm,
                        'yjhcdbh':this.curdForm.yjhcdbh,
                        'yjhcdmc':this.curdForm.yjhcdmc,
                        'tzhskzc':this.curdForm.tzhskzc+'',
                        'tzhxq':this.curdForm.tzhxq,
                        'tzhsjxl':this.curdForm.tzhsjxl+'',
                        'tzhskjsbh':this.curdForm.tzhskjsbh+'',
                        'tzhskjsxm':this.curdForm.tzhskjsxm,
                        'tzhcdbh':this.curdForm.tzhcdbh+'',
                        'tzhcdmc':this.curdForm.tzhcdmc,
                        'otherExplain':this.curdForm.otherExplain,
                        'editType': this.editType,
                        'submitState': this.curdForm.submitState,
                    };
                    this.$api.courseAdjust.courseAdjust.checkEnableSite({
                        data: paramMap,
                    }).then((response) => {
                        let timeorder = response.data.data.timeorder;
                        if(timeorder != ""){
                            var times = timeorder.split(",",-1);
                            for(var i=0;i<times.length;i++){
                                $('#cell_' + times[i]).css('background-color', '#E7FECB');
                            }                        }
                        $('#loadingMask_kb').hide();
                    }).catch((error) => {
                        this.$notify({
                            title: "错误",
                            message: error,
                            type: "error",
                            duration: 3000,
                        });
                    });
                }
            },
            closeTimeTableDialog(){
                this.singleTimeTableVisible = false;
            },
            getCurrentFormatDate(){
                var date = new Date();
                var seperator1 = "-";
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                var currentdate = year + seperator1 + month + seperator1 + strDate;
                return currentdate;
            },
            formatJS(str){
                let result = "";
                let js = str.split(",");
                for(let i=0;i<js.length;i++){
                    result += parseInt(js[i],10)+",";
                }
                if(result!=''){
                    result = result.substring(0,result.length-1);
                }
                return result;
            },
            //批量导出
            exportAdjustInfo(){
                if(this.exportForm.kszc != ''){
                    if(this.exportForm.jszc == ''){
                        this.$message({
                            title: '提示',
                            message: '请选择结束周次!',
                            type: 'warning',
                            duration: 2000,
                        });
                        return;
                    }
                }
                if(this.exportForm.jszc != ''){
                    if(this.exportForm.kszc == ''){
                        this.$message({
                            title: '提示',
                            message: '请选择起始周次!',
                            type: 'warning',
                            duration: 2000,
                        });
                        return;
                    }

                }
                //判断开始时间是否大于结束时间
                if(parseInt(this.exportForm.kszc,10) > parseInt(this.exportForm.jszc,10)){
                    this.$message({
                        title: '提示',
                        message: '起始周次必须在结束周次之前!',
                        type: 'warning',
                        duration: 2000,
                    });
                    return;
                }

                $('#loadingMask').show();

                let obj = {};
                obj = this.xnxqInfo.find((item)=>{
                    return item.comboValue === this.exportForm.xnxqbm;//筛选出匹配数据
                });
                this.exportForm.xnxqmc = obj.comboName;
                this.exportDialogVisible = false;

                const paramMap = {
                    'xnxqbm': this.exportForm.xnxqbm,
                    'xnxqmc': this.exportForm.xnxqmc,
                    'teacherCode': this.exportForm.teacherCode+'',
                    'classCode': this.exportForm.classCode,
                    'courseCode': this.exportForm.courseCode,
                    'kszc': this.exportForm.kszc,
                    'jszc': this.exportForm.jszc,
                }
                this.$api.courseAdjust.courseAdjust.exportAdjustInfo({
                    data: paramMap,
                    responseType: "blob",
                }).then((response) => {
                    if(response.data.size==0){
                        this.$notify({
                            title: '提醒',
                            message: "查询不到调课信息",
                            type: 'warning',
                            duration: 3000,
                        });
                        $('#loadingMask').hide();
                    }else{
                        const content = response.data;
                        const blob = new Blob([content]);

                        let year = new Date().getFullYear();//年
                        let month = new Date().getMonth() +1;//注意！月份是从0月开始获取的，所以要+1;
                        let day = new Date().getDate();//日
                        //拼接日期
                        let yearMD = year + (month >=10 ? month:'0'+ month) + (day >=10 ? day:'0' + day);

                        const fileName = this.exportForm.xnxqmc + " 调课信息汇总" + yearMD + ".xlsx";
                        if ("download" in document.createElement("a")) {
                            // 非IE下载
                            const elink = document.createElement("a");
                            elink.download = fileName;
                            elink.style.display = "none";
                            elink.href = URL.createObjectURL(blob);
                            document.body.appendChild(elink);
                            elink.click();
                            URL.revokeObjectURL(elink.href); // 释放URL 对象
                            document.body.removeChild(elink);
                        } else {
                            // IE10+下载
                            navigator.msSaveBlob(blob, fileName);
                        }
                        $('#loadingMask').hide();
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            closeExportDialog(){
                this.exportForm.teacherCode = '';
                this.exportForm.teacherName = '';
                this.exportForm.classCode = '';
                this.exportForm.courseCode = '';
                this.exportForm.kszc = '';
                this.exportForm.jszc = '';
                this.exportForm.tkType = '';
                this.exportForm.source = '';

                this.exportDialogVisible = false;
            },
            showBtkxx(){
                this.tableLoading = true;
                const paramMap = {
                    'id': this.curdForm.id,
                }
                this.$api.courseAdjust.courseAdjust.queryBtkxx({
                    data: paramMap,
                }).then((response) => {
                    this.btkxxData = response.data.data.list;
                    this.btkxxDialogVisible = true;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            closeBtkxxDialog(){
                this.btkxxDialogVisible = false;
            },
            tzxqFormatter(row){
                let str = "星期"+this.weekarray[parseInt(row.tzhxq,10)-1];
                return str;
            },
            tzjcFormatter(row){
                let str = "";
                let sjxl = row.tzhsjxl.split(",");
                for(let i=0;i<sjxl.length;i++){
                    str += parseInt(sjxl[i],10)+"，";
                }
                if(''!=str){
                    str = str.substring(0,str.length-1);
                }
                return str;
            },
            tzskzcFormatter(row){
                let str = "第"+row.tzhskzc+"周";
                return str;
            },
            //显示loading
            showLoadingMask(str) {
                this.loadingMask = this.$loading({
                    lock: true,
                    text: str,
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.8)",
                });
            },
            //关闭loading
            closeLoadingMask() {
                if (this.loadingMask) this.loadingMask.close();
            },
        },
    };
</script>

<style scoped>
    .el-dialog-div{
        height: 65vh;
        overflow: auto;
    }
    .el-dialog-timetable{
        height: 83vh;
        overflow: auto;
    }
    .attachmentUpload /deep/ .el-upload-dragger {
        width: 480px;
        height: 250px;
    }
    .maskStyle{
        width:100%;
        height:100%;
        overflow:hidden;
        display:none;
        background-color:#000000;
        filter:alpha(opacity=60);
        -moz-opacity:0.6;
        opacity: 0.6;
        position:absolute;
        top:0px;
        left:0px;
        z-index:100;
    }

    .maskFont{
         font-size:16px;
         font-weight:bold;
         color:#ffffff;
         width:230px;
         height:100%;
         position:absolute;
         top:50%;
         left:50%;
         margin-top:-10px;
         margin-left:-115px;
    }

    .timetable {
        width: 100%;
        border-top: 1px solid #DCDFE6;
        border-left: 1px solid #DCDFE6;
        border-collapse: collapse;
        border-spacing: 0;
        text-align: center;
    }

    .timetable tr {
        height: 54px;
    }

    .timetable td {
        border-right: 1px solid #DCDFE6;
        border-bottom: 1px solid #DCDFE6;
        padding: 0;
    }

    .timetableTitle {
        background-color: #F1FAF6;
        font-weight: bold;
    }

    .separetor {
        border-bottom: 4px double #DCDFE6 !important;
    }

    .customElRow .el-row {
        padding-bottom: 0;
    }
</style>



// WEBPACK FOOTER //
// longtermAdjust.vue?0e0c1656